import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { CommonService } from "../../common.service";
import { ExcelServiceService } from "../../excel-service.service";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject } from "rxjs";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { TabsetComponent } from "ngx-bootstrap/tabs/public_api";
import { DataTableDirective } from "angular-datatables";
import { ActivatedRoute } from "@angular/router";
import * as XLSX from "xlsx";
import * as moment from "moment";
import { CommonVariablesService } from "../../common-variables.service";

@Component({
  selector: "app-bulk-declaration",
  templateUrl: "./bulk-declaration.component.html",
  styleUrls: ["./bulk-declaration.component.css"],
})
export class BulkDeclarationComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  @ViewChild("modifyBulkDeclaration") modifyBulkDeclaration: TemplateRef<any>;
  @ViewChild("disclaimer") disclaimer: TemplateRef<any>;
  @ViewChild("uwCase") uwCase: TemplateRef<any>;
  @ViewChild("holdCase") holdCase: TemplateRef<any>;
  @ViewChild("excelTbl") excelTbl: TemplateRef<any>;
  @Input("gcPolicyNo") gcPolicyNo: string;
  @Input("policyRenewalCounter") policyRenewalCounter: string;
  @Input("masterPolicyId") masterPolicyId: string;
  @Input("getUserType") getUserType: string;
  // @Input('isMasterPolicyInactived') isMasterPolicyInactived: boolean;
  @ViewChild("tabset", { static: false }) tabset: TabsetComponent;
  @ViewChild("fileUpload") fileUpload: ElementRef;
  masterPolicyNo = "";
  bulkDeclarationForm: FormGroup;
  bulkDeclUploadData = [];
  isSimpleBulkDeclaration = true;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings = {};
  masterPolicyDetails: any = [];
  bulkConsolidated = "Consolidated";
  bulkTransitLevelDetailed = "Transit level detailed";
  isModify: boolean = false;
  config: any = { class: "theme-modal right modal-sm", backdrop: "static" };
  configCenter: any = {
    class: "theme-modal center modal-sm",
    backdrop: "static",
  };
  modalRef: BsModalRef;
  allowedExt =
    ".xls,.xlsb,.xlsm,.xlsx,.rtf,.docx,.doc,.pdf,.jpg,.jpeg,.png,.zip,.7z";
  allowedFileExt: Array<any> = [
    "xls",
    "xlsb",
    "xlsm",
    "xlsx",
    "rtf",
    "docx",
    "doc",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "zip",
    "7z",
  ];
  allowedXl = ".xls,.xlsb,.xlsm,.xlsx";
  allowedFileXl: Array<any> = ["xls", "xlsb", "xlsm", "xlsx"];
  docDetails: any = {};
  bulkSuccessMsg = "Bulk declaration saved successfully";
  disclamChkFlg: boolean;
  availableBalc: any;
  pageContent: any;
  bulkPageSubscription: any;
  fromDateList: any;
  submitted: boolean = false;
  selectedDeclarationDetail: any;
  docDownloadUrl: any;
  uwActionBtnFlg: boolean = true;
  isNstpEnabled: boolean = false;
  masterPolicyData: any = [];
  header: any;
  uwRefferralReasons: any = [];
  expiryDaysMsg =
    "Bulk declaration date is below the approved backdation limit.";
  isReferred: boolean = false;
  pslMsg =
    "Declaration is on hold and referred to Underwriter as single shipment value exceeds Policy sending limit.";
  prdEndorsementDetails: any;
  fieldError: any = [];
  calcPremiumData: any = {};
  refToUW = "Raised for Underwriter referral";
  uploadHoldMsg = "On hold";
  uploadSuccessMsg = "Uploaded successfully";
  declSuccessMsg = "Declared successfully";
  isNegativeBalnc: boolean = false;
  sysDateObj = new Date();
  endorsementId: any;
  selectedEndorsementData: any;
  errorMsg = "Problem occured while saving data";
  bovMsg =
    'Basis of Valuation % as per Policy is "BOV%", please re-upload with correct values.';
  negativeBalcMsg =
    "Declaration upload has been referred to Underwriter due to insufficient balance.";
  excelData = [
    {
      statusmsg: "",
      serial_Number: "",
      "subject_Matter ": "",
      invoice_No: "",
      invoice_Date: "",
      transit_From: "",
      transit_To: "",
      consignee_Name: "",
      consignee_Address: "",
      carrier_Transporter_Name: "",
      LR_AWB_BL_No: "",
      LR_AWB_BL_date: "",
      invoice_Value: "",
      freight: "",
      Duty_Sum_Insured: "",
    },
  ];
  sampleData = [];
  excelData1 = [
    { statusmsg: "", isMandatory: true, dataType: "Numeric" },
    { serial_Number: "", isMandatory: true, dataType: "Numeric" },
    { "subject_Matter ": "", isMandatory: false, dataType: "Varchar" },
    {
      invoice_No: "",
      isMandatory: true,
      dataType: "Alphanumeric",
      regex: this.commonService.freeTextPattern,
    },
    { invoice_Date: "", isMandatory: true, dataType: "Date" },
    { transit_From: "", isMandatory: false, dataType: "Varchar" },
    { transit_To: "", isMandatory: false, dataType: "Varchar" },
    { consignee_Name: "", isMandatory: false, dataType: "Varchar" },
    { consignee_Address: "", isMandatory: false, dataType: "Varchar" },
    { carrier_Transporter_Name: "", isMandatory: false, dataType: "Varchar" },
    {
      LR_AWB_BL_No: "",
      isMandatory: true,
      dataType: "Alphanumeric",
      regex: this.commonService.freeTextPattern,
    },
    { LR_AWB_BL_date: "", isMandatory: true, dataType: "Date" },
    { invoice_Value: "", isMandatory: true, dataType: "Numeric" },
    { freight: "", isMandatory: false, dataType: "Numeric" },
    { Duty_Sum_Insured: "", isMandatory: false, dataType: "Numeric" },
  ];
  excelHeaders = [
    "statusmsg",
    "Serial Number",
    "Subject Matter ",
    "Invoice No",
    "Invoice Date",
    "Transit From",
    "Transit To",
    "Consignee Name",
    "Consignee Address",
    "carrier/Transporter Name",
    "LR/AWB/BL No.",
    "LR/AWB/BL Date",
    "Invoice Value",
    "Freight (If not included in Invoice)",
    "Duty Sum Insured",
  ];
  excelHeadersKey = [
    "statusmsg",
    "serial_Number",
    "subject_Matter",
    "invoice_No",
    "invoice_Date",
    "transit_From",
    "transit_To",
    "consignee_Name",
    "consignee_Address",
    "carrier_Transporter_Name",
    "LR_AWB_BL_No",
    "LR_AWB_BL_date",
    "invoice_Value",
    "freight",
    "Duty_Sum_Insured",
  ];
  excelRecordVal = 200;
  successTxt = "Success";
  quoteUrl = `${this.commonVariablesService.baseURL}api/v1/quote`;
  impersonateFlag: boolean = false; // added by obulakshmi
  helpDeskMail = "emarine.support@tataaig.com";
  excalValFlag: boolean = false;
  referralRemarksVal: any; //added by Priyadharshini
  isAlreadyGenerated: boolean = true;
  hasVBImpact: boolean = false;
  isBulkMonthly: boolean = false;
  validFromDate: any;
  prevHoldMsg =
    "Your previous declaration/s is/are pending, kindly update the same";
  holdMsg =
    "Last 2 consecutive declaration transaction nil in “Total (Sales/Invoice) Value” field. This referred to underwriter";
  subVoyageAryDetails: any = [];
  policyToDate: any;
  isViewMode: boolean = false;
  gcEndorsementDetails: any = [];
  isTransactionCompleted: boolean = false;
  gcPolicyDetails: any;
  cancelByEndorsement = "Cancelled by endorsement";
  availablePremium: any;
  isMasterPolicyInactived: boolean = false;
  isShowSubmitButton: boolean = false;
  excelProceedButton: boolean = false;
  selectedGcData: any = [];
  isShowBulk = false;
  uwLevel = "";
  bulkDeclarationNo: any;
  isShowButton: boolean = true; //for adminView role
  isSubmitButtonDisable: boolean = false;
  isReferButtonDisable: boolean = false;
  documentId: any; // for documentAttach function

  constructor(
    private fb: FormBuilder,
    public commonService: CommonService,
    public commonVariablesService: CommonVariablesService,
    public datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private el: ElementRef,
    public excelService: ExcelServiceService,
    private titlecasePipe: TitleCasePipe
  ) {
    this.dtOptions = {
      dom: "ftipr",
      destroy: true,
    };
  }

  async ngOnInit() {
    this.uwRefferralReasons = [];
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.fieldError["client_remarks"] = false;
    this.isViewMode = ["marineclaims", "rm", "helpdesk", "ops"].includes(
      (this.getUserType || "").toLowerCase()
    )
      ? true
      : this.header.nav_to == "view_bulk"
      ? true
      : false;
    this.isAlreadyGenerated =
      (this.getUserType == "underwriter" || this.getUserType == "helpdesk") &&
      !this.impersonateFlag &&
      (this.header.nav_to == "upld_appr_rejt" ||
        this.header.nav_to == "view_bulk")
        ? true
        : false;
    const disableFlg = this.isAlreadyGenerated ? true : false;
    const validator = this.isAlreadyGenerated ? Validators.required : "";
    this.bulkDeclarationForm = this.fb.group({
      from_date: [{ value: "", disabled: disableFlg }, Validators.required],
      to_date: [{ value: "", disabled: true }],
      total_sales: [{ value: "" }, Validators.required],
      duty_si: [{ value: "" }],
      file: [{ value: "" }],
      uw_remark: [{ value: "" }, validator],
      vb_impact: [{ value: "" }, validator],
      client_remarks: [{ value: "", disabled: disableFlg }],
      uw_status: [{ value: "" }, validator],
      endorsement_start_date: [{ value: "" }, validator],
      si_deductible: [{ value: "" }],
    });
    this.bulkPageSubscription = this.activatedRoute.params.subscribe((val) => {
      this.onLoadFunctionality(val);
    });
    if (this.getUserType == "adminview") this.isShowButton = false;
  }

  ngOnDestroy() {
    if (this.bulkPageSubscription) {
      this.bulkPageSubscription.unsubscribe();
    }
  }

  /*
   * Created By : Sharann N
   * Description : page onload functionalities.
   *********************************************/
  async onLoadFunctionality(data) {
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    this.pageContent = Number(data.id) || 0;
    this.isMasterPolicyInactived = (this.header.masterpolicy_status || 0) == 1;
    /* let userType = this.cookie.get('userProfile'); */
    let userType = window.localStorage.getItem("userProfile");
    userType = this.commonService.decryptData(userType);
    if (this.pageContent == 5) {
      if (
        userType.toLowerCase() == "produceruser" ||
        userType.toLowerCase() == "hub" ||
        userType.toLowerCase() == "admin" ||
        (userType.toLowerCase() == "underwriter" &&
          this.header.nav_to != "upld_appr_rejt" &&
          this.header.nav_to != "view_bulk")
      ) {
        let policyUrl = `${this.commonVariablesService.baseURL}api/v1/policy`;
        const paramData = {
          policy_no: this.header.policy_no,
        };
        const response = await this.commonService.httpGetMethod(
          policyUrl,
          "application/json",
          true,
          paramData,
          "Declaration",
          this.impersonateFlag
        );
        const ret = response.status == 0 ? response.data[0] || {} : {};
        if (JSON.stringify(ret) == "{}") {
          this.commonService.errorsmsg(
            response.txt || "Unable to get policy details",
            ""
          );
        }
        if (ret) {
          let policyType = ret.quote.data.policy_type;
          if (policyType == "MOP" || policyType == "Open Cover") {
            this.isShowBulk = true;
          } else {
            this.isShowBulk = false;
          }
          await this.getBulkDeclarationProp(ret);
          const impersonateUser = ret["data"]["client_users"][0] || "";
          if (impersonateUser) {
            const url = `${this.commonVariablesService.baseURL}api/v1/auth/impersonate/${impersonateUser}`;
            const res = await this.commonService.httpPostMethod(
              url,
              {},
              "application/json",
              true,
              "Declaration"
            );
            if (res.body.status === 0) {
              sessionStorage.setItem("imp_token", res.body.data.token);
              /* window.localStorage.setItem('imp_token', res.body.data.token); */
              /* sessionStorage.setItem('impersonate_user', 'Yes'); */
              window.localStorage.setItem("impersonate_user", "Yes");
              this.impersonateFlag = true;
            } else if (res.body.status != -114) {
              this.commonService.errorsmsg(
                res.body.txt || "Unable to impersonate",
                ""
              );
            }
          } else {
            this.commonService.errorsmsg(
              "Impersonate: Unable to fetch client details",
              ""
            );
          }
        } else {
          this.commonService.errorsmsg(
            "Impersonate: Unable to fetch mater policy details",
            ""
          );
        }
      }
    }
    this.isAlreadyGenerated =
      (this.getUserType == "underwriter" || this.getUserType == "helpdesk") &&
      !this.impersonateFlag &&
      (this.header.nav_to == "upld_appr_rejt" ||
        this.header.nav_to == "view_bulk")
        ? true
        : false;
    if (this.pageContent == 5) {
      this.header.nav_to = this.header.nav_to || "";
      if (this.header.nav_to == "" && this.gcPolicyNo) {
        this.gcEndorsementDetails =
          await this.commonService.getMasterEndorsement(
            this.gcPolicyNo,
            this.policyRenewalCounter
          );
      }
      await this.loadPolicyDetails();
    }
  }

  /*
   * Created By : Sharann N
   * Description : load the policy details.
   *********************************************/
  async loadPolicyDetails() {
    this.header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    const policyData = await this.getPolicyData(
      this.header.prev_policy_id
        ? this.header.prev_policy_id
        : this.masterPolicyId
    );
    let policyType = policyData.quote.data.policy_type;
    this.isShowBulk = policyType == "MOP" || policyType == "Open Cover";
    this.spinner.show();
    if (policyData.policy_id) {
      this.masterPolicyDetails = policyData;
      if (this.isAlreadyGenerated) {
        this.selectedEndorsementData = await this.getEndorsementIdpolicy();
        this.masterPolicyNo = policyData.master_policy_no;
        await this.checkAssignee();
      } else {
        this.selectedEndorsementData = {};
        this.masterPolicyNo = policyData.policy_no;
      }
      this.gcPolicyDetails = await this.getPolicyData(
        this.masterPolicyNo,
        true
      );
      await this.loadMasterPolicyDetails(true);
      this.isBulkMonthly =
        (this.masterPolicyData.certificate_bulk || "")
          .toLowerCase()
          .replace(/\s/g, "") == "bulk-monthly"
          ? true
          : false;
      const endorsement_id =
        JSON.stringify(this.selectedEndorsementData) == "{}"
          ? ""
          : this.selectedEndorsementData.endorsement_id;
      await this.loadDropdown();
      const consolidated_from_date =
        endorsement_id == ""
          ? this.masterPolicyDetails.quote.data.consolidated_from_date || ""
          : this.selectedEndorsementData.eproposal.data
              .consolidated_from_date || "";
      /* const masterFromDate =  await this.commonService.formatDate(consolidated_from_date, this.isBulkMonthly ? 'LLLL y' : 'dd-MM-yyyy') */
      // const masterFromDate = await this.commonService.formatDate(consolidated_from_date, 'dd-MM-yyyy');
      const masterFromDate = this.datePipe.transform(
        consolidated_from_date,
        "dd-MM-yyyy"
      );
      const fromDate = this.fromDateList.filter(
        (value) => (value.displayText || "") == masterFromDate
      );
      const uw_decl_status = this.isAlreadyGenerated
        ? endorsement_id == ""
          ? this.masterPolicyDetails.qnstp.nstp_status
          : this.selectedEndorsementData.eproposal.data.eproposal_status
        : "";
      const referred_msg = this.isAlreadyGenerated
        ? await this.getReferMsg()
        : "";
      const bulkDeclarationFormData = this.isAlreadyGenerated
        ? {
            from_date: fromDate.length ? fromDate[0].valueText : "",
            to_date: "",
            total_sales:
              endorsement_id == ""
                ? this.masterPolicyDetails.quote.data.consolidated_cargo_value
                : this.selectedEndorsementData.eproposal.data
                    .consolidated_cargo_value,
            duty_si:
              endorsement_id == ""
                ? this.masterPolicyDetails.quote.data.consolidated_duty_si
                : this.selectedEndorsementData.eproposal.data
                    .consolidated_duty_si,
            file: "",
            uw_remark: `${
              referred_msg +
              (this.isViewMode
                ? endorsement_id == ""
                  ? this.masterPolicyDetails.qnstp.nstp_status
                  : this.selectedEndorsementData.eproposal.data.eproposal_status
                : "")
            }`,
            vb_impact: this.isViewMode
              ? (endorsement_id == ""
                  ? this.masterPolicyDetails.quote.data.vb_impact
                  : this.selectedEndorsementData.eproposal.data.vb_impact) ||
                "No"
              : "No",
            client_remarks:
              endorsement_id == ""
                ? this.masterPolicyDetails.quote.data.refferal_remark
                : this.selectedEndorsementData.eproposal.data.client_remarks,
            uw_status: this.isViewMode
              ? (uw_decl_status || "").toLowerCase() == "approved"
                ? "Approve"
                : (uw_decl_status || "").toLowerCase() == "rejected"
                ? "Reject"
                : uw_decl_status
              : "",
            endorsement_start_date:
              endorsement_id == ""
                ? this.sysDateObj
                : new Date(
                    this.selectedEndorsementData.eproposal.data.consolidated_from_date
                  ) || this.sysDateObj,
            si_deductible:
              endorsement_id == ""
                ? this.masterPolicyDetails.quote.data.si_deductible
                : this.selectedEndorsementData.eproposal.data.si_deductible,
          }
        : {
            from_date: "",
            to_date: "",
            total_sales: "",
            duty_si: "",
            file: "",
            uw_remark: "",
            vb_impact: "",
            client_remarks: "",
            uw_status: "",
            endorsement_start_date: this.sysDateObj,
            si_deductible: 0,
          };

      this.policyToDate = bulkDeclarationFormData.to_date;
      this.bulkDeclarationForm.patchValue({
        from_date: bulkDeclarationFormData.from_date,
        to_date: this.policyToDate,
        total_sales: bulkDeclarationFormData.total_sales,
        duty_si: bulkDeclarationFormData.duty_si,
        file: bulkDeclarationFormData.file,
        uw_remark: bulkDeclarationFormData.uw_remark,
        vb_impact: bulkDeclarationFormData.vb_impact,
        client_remarks: bulkDeclarationFormData.client_remarks,
        uw_status: bulkDeclarationFormData.uw_status,
        endorsement_start_date: bulkDeclarationFormData.endorsement_start_date,
        si_deductible: bulkDeclarationFormData.si_deductible,
      });
      await this.reAssignGcData();
      await this.loadBulkDeclaredData();
    }
    this.spinner.hide();
  }

  /*
   * Created By : Sharann N
   * Description : trigger when `from date` value changes.
   *********************************************/
  async dateChange(isFromHtml) {
    const dateValue = this.bulkDeclarationForm.get("from_date").value;
    // const gcPolicyDetails = await this.getPolicyData(this.masterPolicyNo, true);
    // const subVoyageAry = await this.getSubVoyageAry(this.gcPolicyDetails.data.sub_voyage);
    const gcPolicyEndDate: any = new Date(
      this.masterPolicyData.gc_policy_end_date
    );
    if (dateValue) {
      const data = new Date(dateValue);
      const certificateBulk = this.masterPolicyData.certificate_bulk;
      if (
        certificateBulk.toLowerCase().replace(/\s/g, "") == "bulk-fortnightly"
      ) {
        if (data.getDate() >= 16) {
          const lastDate: any = new Date(
            data.getFullYear(),
            data.getMonth() + 1,
            0
          );
          data.setDate(lastDate.getDate());
        } else {
          data.setDate(15);
        }
      } else if (
        certificateBulk.toLowerCase().replace(/\s/g, "") == "bulk-monthly"
      ) {
        const lastDate: any = new Date(
          data.getFullYear(),
          data.getMonth() + 1,
          0
        );
        data.setDate(lastDate.getDate());
      } else if (
        certificateBulk.toLowerCase().replace(/\s/g, "") == "bulk-quarterly"
      ) {
        //64VB second part
        data.setMonth(data.getMonth() + 3);
        data.setDate(data.getDate() - 1);
      } else if (
        certificateBulk.toLowerCase().replace(/\s/g, "") == "bulk-halfyearly"
      ) {
        data.setMonth(data.getMonth() + 6);
        data.setDate(data.getDate() - 1);
        /* count = Number(String((bulkIncrementCount / 2)).slice(0, 3));
        data.setMonth(data.getMonth() + count); */

        // const lastDate: any = new Date(
        //  data.getFullYear(),
        //  data.getMonth() + 6, 0
        // );

        // data.setMonth(lastDate.getMonth())
        // data.setDate(lastDate.getDate());
        // data.setFullYear(lastDate.getFullYear())
      } else if (
        certificateBulk.toLowerCase().replace(/\s/g, "") == "bulk-yearly"
      ) {
        data.setMonth(data.getMonth() + 12);
        data.setDate(data.getDate() - 1);
        //TICKET NO: 233026
      } else {
        data.setDate(data.getDate() - 1);
        // const lastDate: any = new Date(
        //   data.getFullYear(),
        //   data.getMonth() + 1,
        //   0
        // );
        // data.setDate(lastDate.getDate());
      }
      const policyEndDate = this.isAlreadyGenerated
        ? await this.commonService.excelDateToJSDate(
            this.masterPolicyDetails.quote.data.master_policy_end_date
          )
        : this.masterPolicyDetails.quote.data.gc_policy_end_date;
      if (
        new Date(policyEndDate).getMonth() == data.getMonth() &&
        new Date(policyEndDate).getFullYear() == data.getFullYear() &&
        new Date(policyEndDate).getDate() <= data.getDate()
      ) {
        data.setDate(new Date(policyEndDate).getDate());
      }
      this.bulkDeclarationForm.patchValue({ to_date: data });
    } else {
      this.bulkDeclarationForm.patchValue({ to_date: null });
    }
    this.policyToDate = this.bulkDeclarationForm.controls.to_date.value;
    const diffDays = Math.floor(
      (gcPolicyEndDate - this.policyToDate) / (1000 * 60 * 60 * 24)
    );
    if (diffDays > -1) {
      if (isFromHtml) {
        await this.reAssignGcData();
        await this.loadBulkDeclaredData(isFromHtml);
      }
    } else {
      this.bulkDeclarationForm.patchValue({ to_date: gcPolicyEndDate });
    }
  }

  /*
   * Created By : Sharann N
   * Description : load previous declaration data in datatable.
   *********************************************/
  async loadBulkDeclaredData(isFromHtml = false) {
    this.spinner.show();
    /* const subVoyageAry = (this.isAlreadyGenerated) ? {
      id: this.masterPolicyDetails.quote.data.sub_voyage_id
    } : await this.getSubVoyageAry(this.masterPolicyDetails.data.sub_voyage); */
    const policyListUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/list`;
    let policyRefNum = [];

    let ref = window.localStorage.getItem("allPolicyrefNum");
    if (ref) {
      ref.split(",").forEach((value) => {
        policyRefNum.push(value);
      });
    }

    if (
      (this.masterPolicyDetails.quote.data.policy_ref_num ||
        this.masterPolicyDetails.quote.data.cust_fld_8 ||
        "") != ""
    ) {
      policyRefNum.push(
        this.masterPolicyDetails.quote.data.policy_ref_num ||
          this.masterPolicyDetails.quote.data.cust_fld_8
      );
    }
    // this.gcEndorsementDetails.forEach(function (value){
    //   if (policyRefNum.indexOf(value.policy_ref_num) == -1) policyRefNum.push(value.policy_ref_num)
    // })
    var that = this;
    (this.gcEndorsementDetails || []).forEach(function (value) {
      if (
        policyRefNum.indexOf(value.policy_ref_num) == -1 &&
        that.header.policy_start_date_dt == value.policy_inception_date &&
        (that.header.policy_end_date_dt == value.policy_expiry_date ||
          that.header.policy_end_date_endorsement == value.policy_expiry_date)
      )
        if (value.policy_code != "NC" && value.policy_code != "RC")
          policyRefNum.push(value.policy_ref_num);
    });

    policyRefNum = policyRefNum.filter(function (item, pos) {
      return policyRefNum.indexOf(item) == pos;
    });
    const paramData = {
      gc_policy_no: this.gcPolicyNo,
      declaration_type: this.isSimpleBulkDeclaration
        ? this.bulkConsolidated
        : this.bulkTransitLevelDetailed,
      policy_ref_num: policyRefNum.toString(),
      product_id: this.commonVariablesService.declarationProductId,
      cust_fld_3: this.masterPolicyNo,
      // sub_voyage_id: subVoyageAry.id || 0,
      gc_running_id: this.gcPolicyDetails.quote.data.voyage.gc_running_id,
    };
    const response = await this.commonService.httpGetMethod(
      policyListUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status == 0) {
      response.data = response.data || [];
      const responseData = response.data;
      this.bulkDeclUploadData = [];
      if (responseData.length > 0) {
        for (const policyData of responseData) {
          if (policyData) {
            const invalid =
              policyData.quote.cust_fld_2 == this.bulkConsolidated &&
              !policyData.policy_no &&
              (policyData.qnstp_case || "").toLowerCase() == "no";
            if (invalid) {
              continue;
            }
            const consolidated_from_date =
              policyData.quote.data.consolidated_from_date || "";
            const consolidated_to_date =
              policyData.quote.data.consolidated_to_date || "";
            // const fromDate = await this.commonService.formatDate(consolidated_from_date, 'dd-MM-yyyy');
            const fromDate = this.datePipe.transform(
              consolidated_from_date,
              "dd-MM-yyyy"
            );
            const fromDateObj =
              consolidated_from_date.indexOf("T") === -1
                ? await this.convertToDateString(consolidated_from_date)
                : consolidated_from_date;
            // const toDate = await this.commonService.formatDate(consolidated_to_date, 'dd-MM-yyyy');
            const toDate = this.datePipe.transform(
              consolidated_to_date,
              "dd-MM-yyyy"
            );
            const toDateObj =
              consolidated_to_date.indexOf("T") === -1
                ? await this.convertToDateString(consolidated_to_date)
                : consolidated_to_date;
            const endrosementData =
              (policyData.endrosement || [])[
                policyData.endrosement.length - 1
              ] || {};
            const isEndorsement =
              (endrosementData.endorsement_id || "") != "" &&
              JSON.stringify((endrosementData.eproposal || {}).data || {}) !=
                "{}" &&
              endrosementData.eproposal_no;
            // const isEndorsement = ((endrosementData.endorsement_id || '' != '') && JSON.stringify((endrosementData.eproposal || {}).data || {}) != '{}') ? true : false;
            let uw_decl_status = isEndorsement
              ? endrosementData.eproposal.data.eproposal_status || "-"
              : policyData.qnstp.nstp_status || "-";
            uw_decl_status = await this.commonService.convertToPastTense(
              uw_decl_status
            );
            const docDetail =
              isEndorsement && uw_decl_status != "-"
                ? endrosementData
                : policyData;
            uw_decl_status = this.titlecasePipe.transform(uw_decl_status);
            // document attach changes
            let tmpLength = (docDetail.document) ? ((docDetail.document.details.length > 0) ? (docDetail.document.details.length) : 0) : 0;
            const proofName = ((((docDetail.document || {}).details || [])[(tmpLength == 0 ? 0 : (tmpLength - 1))] || '').name || '-');
            const ext = proofName.substring(proofName.lastIndexOf(".") + 1);
			//on-hold issue
			const decl_status = this.isMasterPolicyInactived
			? this.cancelByEndorsement
			: policyData.assigned_to == policyData.created_by
			? (
			this.isSimpleBulkDeclaration
		   ? this.uploadSuccessMsg
			: this.declSuccessMsg
			)
		   :( 
			(policyData.endrosement[policyData.endrosement.length - 1]|| '') 
		   && policyData.endrosement[policyData.endrosement.length - 1].assigned_to != policyData.endrosement[policyData.endrosement.length - 1].created_by 
		   ? this.uploadHoldMsg 
		   :(policyData.quote.data.nstpyn || '').toLowerCase() === 'yes' ? this.uploadHoldMsg :this.uploadSuccessMsg
		   )
            const tableData = isEndorsement
              ? endrosementData.eproposal.data
              : policyData.quote.data;
            const isNSTPApproval = isEndorsement
              ? false
              : (policyData.qnstp.nstp_status || "-").toLowerCase() ==
                "approved";
            const total_sales: any = await this.checkInvalidAmount(
              this.isSimpleBulkDeclaration
                ? tableData.consolidated_cargo_value
                : tableData.detailed_total_value
            );
            const isZeroDecl =
              this.isSimpleBulkDeclaration &&
              Number(tableData.covered_value) == 0.0
                ? true
                : false;
            const after_balance =
              policyData.prev_after_balance.after_balance || 0;
            const before_balance =
              policyData.prev_after_balance.before_balance || 0;
            /* const after_balance = ((policyData || {}).prev_after_balance || {}).after_balance || 0;
            const before_balance = ((policyData || {}).prev_after_balance || {}).before_balance || 0; */
            this.bulkDeclarationNo = policyData.policy_no
              ? policyData.quote.cust_fld_6
                ? policyData.quote.cust_fld_6
                : policyData.policy_no
              : policyData.quote.cust_fld_5
              ? policyData.quote.cust_fld_5
              : policyData.quote_id;

            this.bulkDeclUploadData.push({
              action: [
                { navTo: 6, displayText: "View History", valueText: "history" },
              ],
              idx: this.bulkDeclUploadData.length,
              from_date: fromDate,
              from_date_obj: fromDateObj,
              to_date: toDate,
              to_date_obj: toDateObj,
              //total_sales: isZeroDecl ? 0.0 : total_sales,
              total_sales:
                isZeroDecl && tableData.total_declared_value == 0
                  ? 0.0
                  : total_sales,
              bov_percentage: policyData.quote.data.pol_bov,
              //cargo_value: isZeroDecl ? 0.0 : (this.isSimpleBulkDeclaration) ? tableData.declared_cargo_value : tableData.detailed_cargo_value,
              cargo_value:
                isZeroDecl && tableData.total_declared_value == 0
                  ? 0.0
                  : this.isSimpleBulkDeclaration
                  ? tableData.declared_cargo_value
                  : tableData.detailed_cargo_value,
              //duty_si: isZeroDecl ? 0.0 : (this.isSimpleBulkDeclaration) ? tableData.consolidated_duty_si : tableData.detailed_duty_si,
              duty_si:
                isZeroDecl && tableData.total_declared_value == 0
                  ? 0.0
                  : this.isSimpleBulkDeclaration
                  ? tableData.consolidated_duty_si
                  : tableData.detailed_duty_si,
              //total_declare: isZeroDecl ? 0.0 : tableData.total_declared_value,
              total_declare:
                isZeroDecl && tableData.total_declared_value == 0
                  ? 0.0
                  : tableData.total_declared_value,
              total_premium: isZeroDecl
                ? 0.0
                : isNSTPApproval
                ? policyData.proposal.data.net_premium_final
                : tableData.net_premium_final,
              covered: isZeroDecl ? 0.0 : tableData.covered_value,
              avail_balance: isZeroDecl ? before_balance : after_balance,
              before_balance: before_balance,
              after_balance: after_balance,
              proof: proofName,
              link: `${this.commonVariablesService.baseURL}api/v${
                isEndorsement && uw_decl_status != "-" ? "2" : "1"
              }/document/data/${
                docDetail.document_id + "/" + ext + "/" + proofName
              }?download=1&token=${encodeURIComponent(
                sessionStorage.getItem("token")
              )}`,
              /* link: `${this.commonVariablesService.baseURL}api/v${((isEndorsement && uw_decl_status != '-') ? '2' : '1')}/document/data/${docDetail.document_id + '/' + ext + '/' + proofName}?download=1&token=${encodeURIComponent(window.localStorage.getItem('token'))}`, */
              status: decl_status,
              uw_status: uw_decl_status,
              uw_remarks: isEndorsement
                ? endrosementData.eproposal.data.eproposal_reason || "-"
                : (((policyData.qnstp || {}).details || [])[0] || "").reason ||
                  "-",
              client_action: "Modify",
              policy_id: policyData.policy_id,
              quote_id: policyData.quote_id,
              master_policy_no: policyData.master_policy_no,
              policy_no: policyData.policy_no,
              sub_voyage_id: policyData.quote.data.sub_voyage_id,
              declaration_no: this.bulkDeclarationNo,
              endrosement: policyData.endrosement,
              able_to_reupload:
                !isEndorsement &&
                (uw_decl_status || "").toLowerCase() == "rejected"
                  ? true
                  : false,
              is_endorsement: isEndorsement,
              disableModify: this.bulkDeclarationNo.startsWith("D")
                ? true
                : false,
            });
          }
        }
        await this.assignPrevBalance();
      }
      if (!this.isAlreadyGenerated) {
        const invalidUpldData = this.bulkDeclUploadData.filter(
          (bulkDeclObj) => {
            return bulkDeclObj.able_to_reupload;
          }
        );
        //64VB changes
        if (
          this.fromDateList.length ==
            this.bulkDeclUploadData.length - invalidUpldData.length &&
          invalidUpldData.length !== 0
        ) {
          this.fromDateList = [];
        } else {
          for (let i = 0, len = this.bulkDeclUploadData.length; i < len; i++) {
            for (let j = 0, len2 = this.fromDateList.length; j < len2; j++) {
              if (
                new Date(
                  this.bulkDeclUploadData[i].from_date_obj
                ).toDateString() ===
                  new Date(this.fromDateList[j].valueText).toDateString() &&
                this.bulkDeclUploadData[i].able_to_reupload == false
              ) {
                this.fromDateList.splice(j, 1);
                len2 = this.fromDateList.length;
              }
            }
          }
        }
        if (!isFromHtml) {
          this.validFromDate = this.fromDateList.length
            ? this.fromDateList[0].valueText
            : "";
          this.bulkDeclarationForm.patchValue({
            from_date: this.validFromDate,
          });
        }
      }
      if (this.fromDateList.length) {
        await this.loadMasterPolicyDetails(false);
        await this.dateChange(false);
        this.isTransactionCompleted = false;
      } else {
        this.isTransactionCompleted = true;
      }
      const balance = await this.calcPolicyBalance(this.masterPolicyNo, "");
      this.availableBalc = balance.available_opening_balance_bulk;
      this.availablePremium = balance.available_premium_balance_bulk;
      return true;
    } else if (response.status != -114) {
      this.spinner.hide();
      this.commonService.errorsmsg(response.txt, "");
      return false;
    }
  }

  /*
   * Created By : Sharann N
   * Description : get the policy details.
   *********************************************/
  async getPolicyData(policyId, isPolicyNo: boolean = false) {
    const policyUrl = `${this.commonVariablesService.baseURL}api/v1/policy`;
    const paramData = {};
    isPolicyNo
      ? (paramData["policy_no"] = policyId)
      : (paramData["policy_id"] = policyId);
    const response = await this.commonService.httpGetMethod(
      policyUrl,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status != 0 && response.status != -114) {
      this.commonService.errorsmsg(response.txt, "");
    }
    // for documentAttach function
    if (!isPolicyNo) {
    this.documentId = response.data[0].document_id;
    }
    return response.data[0] || {};
  }

  /*
   * Created By : Sharann N
   * Description : navigate to child component.
   *********************************************/
  async gotoPageContent(pageId) {
    await this.commonService.navigateToDecl(pageId);
  }

  /*
   * Created By : Sharann N
   * Description : trigger when the file input changes.
   *********************************************/
  async onFileChange(event) {
    //this.excelData = [];
    this.spinner.show();
    // this.submitted = true;
    this.docDetails = {};
    const file = event.target.files[0]; // <--- File Object for future use.
    if (file) {
      let workBook = null;
      const reader = new FileReader();
      reader.onload = () => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: "binary" });
        let firstsheet = workBook.SheetNames[0];
        const sheet = workBook.Sheets[firstsheet];
        this.excelData = XLSX.utils.sheet_to_json(sheet);
      };
      reader.readAsBinaryString(file);
    }
    this.bulkDeclarationForm.controls.file.setValue(file ? file : "");
    this.spinner.hide();
    if (
      !event ||
      !event.target ||
      !event.target.files ||
      event.target.files.length === 0
    ) {
      return;
    }
    const name = event.target.files[0].name;
    const lastDot = name.lastIndexOf(".");
    const ext = name.substring(lastDot + 1);
    this.docDetails = {
      file_name: name,
      file_ext: ext,
    };
    let fileSize = event.target.files[0].size;
    if (fileSize / 1024 / 1024 <= 5) {
      if (
        (this.isSimpleBulkDeclaration
          ? this.allowedFileExt.indexOf(ext.toLowerCase())
          : this.allowedFileXl.indexOf(ext.toLowerCase())) === -1
      ) {
        this.bulkDeclarationForm.controls.file.setErrors({
          file_extension: true,
        });
      }
    } else if (fileSize / 1024 / 1024 > 5) {
      this.bulkDeclarationForm.controls.file.setErrors({ file_size: true });
    }
    if (name.length > 64) {
      this.bulkDeclarationForm.controls.file.setErrors({ file_size: true });
    }
  }

  /*
   * Created By : Sharann N
   * Description : to open disclaimer with conditions.
   *********************************************/
  async openDisclaimer(template: TemplateRef<any>) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.isShowSubmitButton = true;
    if (!this.isSimpleBulkDeclaration) {
      this.submitted = true;
      this.spinner.show();
      const ret = await this.validateForm();
      if (ret) {
        this.spinner.hide();
        this.excalValFlag = await this.excelFieldValidation();
        if (!this.excalValFlag) {
          this.fileUpload.nativeElement.value = null;
        }
        const recordLength = this.excelData.length;
        if (recordLength > this.excelRecordVal) {
          this.commonService.errorsmsg(
            "Maximum 200 records can be uploaded",
            ""
          );
          //Ticket No 154865
          this.isShowSubmitButton = false;
        } else {
          this.excelProceedButton = !this.excalValFlag;
          this.modalRef = await this.modalService.show(
            this.excelTbl,
            this.configCenter
          );
        }
      } else {
        //Ticket No 154865
        this.isShowSubmitButton = false;
        this.spinner.hide();
      }
    } else {
      this.spinner.show();
      await this.proceedWithDeclr(template);
    }
  }

  /*
   * Created By : Sharann N
   * Description : check before display excel upload preview.
   *********************************************/
  async proceedDetailedDeclr(template: TemplateRef<any>) {
    this.excelProceedButton = true;
    this.spinner.show();
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      this.spinner.hide();
      return;
    }
    if (this.excalValFlag) {
      await this.proceedWithDeclr(template);
    } else {
      this.spinner.hide();
    }
  }

  /*
   * Created By : Sharann N
   * Description : validate the user entered valid date range.
   *********************************************/
  async proceedWithDeclr(template) {
    //64VB currYear change
    let listDate, listMonth, selectedBulkDetail, listYear;
    this.submitted = true;
    this.spinner.show();
    const ret = await this.validateForm();
    if (ret) {
      if (this.bulkDeclarationForm.valid) {
        this.spinner.hide();
        //Ticket No 154865
        this.isShowSubmitButton = true;
        const frDate = new Date(
          this.bulkDeclarationForm.controls.from_date.value
        );
        const curDate = frDate.getDate();
        const curMonth = frDate.getMonth() + 1;
        const curYear = frDate.getFullYear();
        listDate = "";
        listMonth = "";

        selectedBulkDetail = "";
        if (this.bulkDeclUploadData.length) {
          selectedBulkDetail = this.bulkDeclUploadData.filter((value) => {
            return (
              new Date(value.from_date_obj).toDateString() ===
              new Date(this.f.from_date.value).toDateString()
            );
          });
          // let from_date = await this.commonService.formatDate(this.bulkDeclUploadData[0]['from_date'], 'dd-MM-yyyy');
          let from_date = this.bulkDeclUploadData[0]["from_date"] || "--";
          const date = from_date.split("-");
          listDate = date[0];
          listMonth = date[1];
          listYear = date[2];
        }

        const fromDateObj =
          typeof this.fromDateList[0].valueText == "string"
            ? this.fromDateList[0].valueText.indexOf("T") === -1
              ? await this.convertToDateString(this.fromDateList[0].valueText)
              : new Date(this.fromDateList[0].valueText)
            : this.fromDateList[0].valueText;

        if (listMonth == "" && fromDateObj.getTime() == frDate.getTime()) {
          await this.checkForm(template);
        } else {
          if (
            curMonth == listMonth &&
            curDate == listDate &&
            curYear == listYear &&
            this.bulkDeclarationForm.valid &&
            ((selectedBulkDetail[0] || "").able_to_reupload || false) == false
          ) {
            this.excelProceedButton = false;
            this.commonService.errorsmsg(
              "Already data entered for the selected Month",
              ""
            );
          } else if (
            this.bulkDeclarationForm.controls.from_date.value !=
              this.validFromDate &&
            this.bulkDeclarationForm.valid
          ) {
            this.excelProceedButton = false;
            //Ticket No 154865
            this.isShowSubmitButton = false;
            this.commonService.errorsmsg(this.prevHoldMsg, "");
          } else if (
            this.bulkDeclarationForm.controls.from_date.value ==
              this.validFromDate &&
            this.bulkDeclarationForm.valid
          ) {
            await this.checkForm(template);
          } else {
            this.excelProceedButton = false;
            //Ticket No 154865
            this.isShowSubmitButton = false;
            this.spinner.hide();
          }
        }
      } else {
        //Ticket No 154865
        this.isShowSubmitButton = false;
        this.excelProceedButton = false;
        this.spinner.hide();
      }
    } else {
      //Ticket No 154865
      this.isShowSubmitButton = false;
      this.excelProceedButton = false;
      this.spinner.hide();
    }
  }

  /*
   * Created By : Sharann N
   * Description : to validate the form.
   *********************************************/
  async validateForm(flow = "") {
    if (this.isModify || !this.isSimpleBulkDeclaration) {
      await this.clearValidators(this.bulkDeclarationForm);
      await this.changeuwActionFlag(true);
    }
    const formFieldAry = this.isModify
      ? ["client_remarks"]
      : (this.getUserType != "underwriter" && this.getUserType != "helpdesk") ||
        this.impersonateFlag
      ? this.isSimpleBulkDeclaration
        ? ["total_sales"]
        : ["file"]
      : ["uw_remark", "vb_impact", "uw_status"];
    for (const formField of formFieldAry) {
      this.bulkDeclarationForm
        .get(formField)
        .setValidators([Validators.required]);
      this.bulkDeclarationForm.get(formField).updateValueAndValidity();
    }
    this.fieldError["total_sales"] = false;
    let isOnHoldCase = false;
    if (flow != "uw_action") {
      // check wheather prev. declaration is in "On hold" or not
      const isOnHold =
        this.bulkDeclUploadData.length > 0 &&
        this.bulkDeclUploadData.some(
          (value) =>
            value.status === this.uploadHoldMsg &&
            (value.uw_status || "").toLowerCase() != "rejected"
        )
          ? true
          : false;
      if (
        isOnHold &&
        this.bulkDeclarationForm.valid &&
        this.getUserType != "underwriter"
      ) {
        await this.closeModal();
        this.modalRef = await this.modalService.show(
          this.holdCase,
          this.configCenter
        );
        this.spinner.hide();
        return false;
      }

      const len = this.bulkDeclUploadData.length;
      const isLastTwoSalesZero =
        len >= 2 &&
        (this.bulkDeclUploadData[len - 2].total_sales == 0 ||
          this.bulkDeclUploadData[len - 2].total_sales == 0.01 ||
          this.bulkDeclUploadData[len - 2].total_sales == 0.001) &&
        (this.bulkDeclUploadData[len - 1].total_sales == 0 ||
          this.bulkDeclUploadData[len - 1].total_sales == 0.01 ||
          this.bulkDeclUploadData[len - 1].total_sales == 0.001)
          ? true
          : false;
      if (
        this.isSimpleBulkDeclaration &&
        !this.isModify &&
        (this.bulkDeclarationForm.controls.total_sales.value || 0) == 0
      ) {
        if (
          isLastTwoSalesZero &&
          this.bulkDeclarationForm.controls.total_sales.value == 0
        ) {
          isOnHoldCase = true;
        }
      }
      await this.pushReferralReason(isOnHoldCase, this.holdMsg);
      if (isOnHoldCase) {
        // this.uwRefferralReasons.push(this.holdMsg);
        this.modalRef = await this.modalService.show(
          this.uwCase,
          this.configCenter
        );
        this.spinner.hide();
        return false;
      }
    }

    if (
      !this.isModify &&
      !this.isSimpleBulkDeclaration &&
      (this.bulkDeclarationForm.controls.file.value || "") == "" &&
      this.bulkDeclarationForm.controls.uw_status.value == "Approve"
    ) {
      this.fieldError["file"] = true;
      this.bulkDeclarationForm.controls.file.setErrors({ required: true });
      this.spinner.hide();
      return false;
    }
    let balance = await this.calcPolicyBalance(
      this.masterPolicyNo,
      //64VB changes
      this.f.to_date.value || ""
    );
    if (balance.available_opening_balance_bulk > this.availableBalc) {
      balance.available_opening_balance_bulk = this.availableBalc;
    }
    const totalDeclared =
      JSON.stringify(this.calcPremiumData) != "{}"
        ? this.calcPremiumData.cells.total_declared_value || 0
        : 0;
    this.isNegativeBalnc =
      totalDeclared - balance.available_opening_balance_bulk > 0 ? true : false;
    if (this.bulkDeclarationForm.invalid) {
      this.submitted = true;
      return false;
    }
    return true;
  }

  /*
   * Created By : Sharann N
   * Description : to upload the bulk declaration data.
   *********************************************/
  async uploadDeclarationData() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.isReferButtonDisable = true;
    if (this.isSimpleBulkDeclaration) {
      if (!this.isModify) {
        await this.closeModal();
      }
      this.isShowSubmitButton = true;
      await this.saveQuote();
      this.isReferButtonDisable = false;
    } else {
      const excelValue = await this.productInputAttach();
      await this.saveQuote(excelValue);
      this.isReferButtonDisable = false;
    }
  }

  /*
   * Created By : Sharann N
   * Description : save the bulk declaration.
   *********************************************/
  async saveQuote(data: any = {}) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.spinner.show();
    const ret = await this.validateForm();
    if (ret) {
      if (this.bulkDeclarationForm.valid) {
        const ret1 =
          !this.isModify && this.getUserType != "helpdesk"
            ? await this.checkUwCase(data)
            : 1;
        if (ret1 == 0) {
          this.openModal(this.uwCase);
        } else if (ret1 == 1) {
          this.checkEndorsement(data);
        }
        // (ret1 == 0) ? this.openModal(this.uwCase) : (ret1 == 1) ? this.checkEndorsement(data) : '';
      } else {
        //Ticket No 154865
        this.isShowSubmitButton = false;
        this.spinner.hide();
        this.commonService.warningmsg(
          "Please fill Mandatory fields",
          "Warning"
        );
      }
    } else {
      this.spinner.hide();
      //Ticket No 154865
      this.isShowSubmitButton = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
    }
  }

  /*
   * Created By : Sharann N
   * Description : to close the modal.
   *********************************************/
  closeModal() {
    return new Promise(async (resolve) => {
      if (this.modalRef) {
        this.isReferred = true;
        this.isShowSubmitButton = false;
        this.modalRef.hide();
      }
      resolve(true);
    });
  }

  /*
   * Created By : Sharann N
   * Description : agree to do bulk declaration for simple.
   *********************************************/
  changeDisclamChkFlg() {
    if ($("#agree").prop("checked")) {
      $("#agree").prop("checked", false);
      this.disclamChkFlg = false;
    } else {
      $("#agree").prop("checked", true);
      this.disclamChkFlg = true;
    }
  }

  /*
   * Created By : Sharann N
   * Description : open modify declaration modal template.
   *********************************************/
  async openModifyModal(template: TemplateRef<any>, data) {
    // if (data.status == this.isSimpleBulkDeclaration ? this.uploadSuccessMsg : this.declSuccessMsg && (data.uw_status == '-' || (data.is_endorsement == false && data.uw_status.toLowerCase() == 'approved')) && !this.isViewMode) {
    if (
      data.status == this.isSimpleBulkDeclaration
        ? this.uploadSuccessMsg
        : this.declSuccessMsg && !this.isViewMode
    ) {
      this.isModify = true;
      this.selectedDeclarationDetail = data;
      this.modalRef = await this.modalService.show(template, this.configCenter);
    }
  }

  /*
   * Created By : Sharann N
   * Description : set value to client remarks form field.
   *********************************************/
  changeuwActionFlag(isAwait: boolean = false) {
    if (
      this.getUserType != "underwriter" ||
      (this.getUserType == "underwriter" && this.impersonateFlag)
    ) {
      let client_remarks = $("#client_remarks").val();
      client_remarks = client_remarks
        ? client_remarks
        : this.f.client_remarks.value;
      this.fieldError["client_remarks"] = client_remarks ? false : true;
      this.bulkDeclarationForm.controls.client_remarks.setValue(client_remarks);
    }
    if (isAwait) {
      return new Promise((resolve) => {
        resolve(true);
      });
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get the excel data as api response.
   *********************************************/
  async productInputAttach() {
    const productAttachUrl =
      this.commonVariablesService.baseURL +
      "api/v1/product/attach/input/" +
      this.commonVariablesService.declarationProductId;
    const name = this.bulkDeclarationForm.controls.file.value;
    let ret = {};
    if (name) {
      const fileData = new FormData();
      fileData.append("file", name);
      fileData.append("file_type", this.docDetails.file_ext);
      fileData.append("name", this.docDetails.file_name);
      const response = await this.commonService.httpPostMethod(
        productAttachUrl,
        fileData,
        "",
        true,
        "Declaration",
        this.impersonateFlag
      );
      ret = response.body.data || {};
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : to download sample excel format.
   *********************************************/
  downloadSampleFormat() {
    const fileName = "bulk-detailed-template.xlsx";
    const dwldSampleUrl = `./assets/excel/${fileName}`;
    window.open(dwldSampleUrl, "_blank"); //To download the Document in new Tab
  }

  /*
   * Created By : Sharann N
   * Description : to rerender the datatable.
   *********************************************/
  async rerender() {
    $("#bulk_table").DataTable().destroy();
    this.isModify = false;
    await this.closeModal();
    const ret = await this.loadBulkDeclaredData();
    if (ret) {
      this.tabset.tabs[1].active = true;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to load the dropdown value.
   *********************************************/
  async loadDropdown() {
    this.fromDateList = [];
    // const gcPolicyDetails = await this.getPolicyData(this.masterPolicyNo, true);
    const subVoyageAry = await this.getSubVoyageAry(
      this.gcPolicyDetails.data.sub_voyage
    );
    let certificateBulk = await this.getCertificateBulk(
      this.gcPolicyDetails.data.declaration_type_sub_voyage,
      subVoyageAry
    );
    certificateBulk = (certificateBulk || "").toLowerCase().replace(/\s/g, "");
    // const policyStartDate = (this.isAlreadyGenerated) ? await this.commonService.excelDateToJSDate(this.masterPolicyDetails.quote.data.master_policy_start_date) : this.masterPolicyDetails.quote.data.gc_policy_start_date;
    const policyStartDate = this.isAlreadyGenerated
      ? await this.commonService.excelDateToJSDate(
          this.masterPolicyDetails.quote.data.master_policy_start_date
        )
      : this.masterPolicyData.gc_policy_start_date;
    let arrObjCount = 12;
    let bulkDeclationType = 1;
    //64VB changes
    const expiryDate: any = new Date(this.masterPolicyData.gc_policy_end_date);
    let monthDiff =
      expiryDate.getMonth() -
      new Date(policyStartDate).getMonth() +
      12 * (expiryDate.getFullYear() - new Date(policyStartDate).getFullYear());

    if (certificateBulk == "bulk-fortnightly") {
      arrObjCount = (monthDiff + 1) * 2;
      // arrObjCount = 24;
      bulkDeclationType = 0.5;
    } else if (certificateBulk == "bulk-monthly") {
      arrObjCount = monthDiff + 1;

      // already bulkDeclationType is 1(no need to assign again)
      // bulkDeclationType = 1;
    } else if (certificateBulk == "bulk-quarterly") {
      arrObjCount = monthDiff + 1;
      bulkDeclationType = 3;
    } else if (certificateBulk == "bulk-halfyearly") {
      arrObjCount = monthDiff + 1;
      bulkDeclationType = 6;
    } else if (certificateBulk == "bulk-yearly") {
      arrObjCount = monthDiff + 1;
      bulkDeclationType = 12;
    // }else{
    //   arrObjCount = monthDiff + 1;
     }
    await this.addMonths(
      new Date(policyStartDate),
      bulkDeclationType,
      arrObjCount,
      arrObjCount
    );
  }

  /*
   * Created By : Sharann N
   * Description : add months in the object array.
   *********************************************/
  async addMonths(date, months, iteration, count) {
    while (iteration) {
      const tempDate = date.getDate();
      if (date.getDate() != tempDate) {
        date.setDate(0);
      }
      if (months == 0.5) {
        if (iteration < count) {
          date.getDate() >= 16 ? date.setDate(1) : date.setDate(16);
        }
      } else if (months == 1) {
        if (iteration < count) {
          date.setDate(date.getDate() - (tempDate - 1));
        }
      }
      const expiryDate: any = new Date(
        this.masterPolicyData.gc_policy_end_date
      );
      if (iteration != count) {
        months == 0.5 && date.getDate() < 16
          ? date.setMonth(date.getMonth() + 1)
          : months == 0.5 && date.getDate() >= 16
          ? date.setMonth(date.getMonth() + 0)
          : date.setMonth(date.getMonth() + +months);
      }
      const diffDays = Math.floor((expiryDate - date) / (1000 * 60 * 60 * 24));
      // if (iteration != count) {
      //   (months == 0.5 && date.getDate() < 16) ? date.setMonth(date.getMonth() + 1) : (months == 0.5 && date.getDate() >= 16) ? date.setMonth(date.getMonth() + 0) : date.setMonth(date.getMonth() + +months);
      // }
      if (diffDays > -1) {
        this.fromDateList.push({
          displayText: this.datePipe.transform(date, "dd-MM-yyyy"),
          valueText: JSON.parse(JSON.stringify(date)),
        });
      }
      iteration = iteration - 1;

      // this.addMonths(date, months, --iteration, count, certificateBulk);
    }
  }

  /*
   * Created By : Sharann N
   * Description : to calculate the premium of bulk declaration.
   *********************************************/
  async calculateBulkPremium(excelValue: any = {}) {
    let invalid = false;
    if (!this.isModify && this.isSimpleBulkDeclaration) {
      const total_sales = Number(
        await this.removeSeparator(
          this.bulkDeclarationForm.controls.total_sales.value
        )
      );
      if (isNaN(total_sales)) {
        invalid = true;
        this.bulkDeclarationForm.controls.total_sales.setErrors({
          required: true,
        });
      }
    }

    if (invalid) {
      this.spinner.hide();
      return;
    }

    const premiumCalcUrl = `${this.commonVariablesService.baseURL}api/v1/product/calc`;
    const isModify = this.isAlreadyGenerated ? true : false;
    const subVoyageAry = isModify
      ? {
          coverage_type: this.masterPolicyDetails.quote.data.coverage_type,
          certificate_bulk: this.isSimpleBulkDeclaration
            ? "simple"
            : "detailed",
          bov_percentage: this.masterPolicyDetails.quote.data.bov_percentage,
          id: this.masterPolicyDetails.quote.data.sub_voyage_id,
          min_shipment_premium:
            this.masterPolicyDetails.quote.data.min_shipment_premium,
        }
      : await this.getSubVoyageAry(this.masterPolicyDetails.data.sub_voyage);
    // const masterPolicyNo = isModify ? this.masterPolicyDetails.master_policy_no : this.masterPolicyDetails.policy_no;
    const policyId = isModify ? this.masterPolicyDetails.policy_id : "";
    let balance = await this.calcPolicyBalance(
      this.masterPolicyNo,
      //64VB changes
      this.f.to_date.value
    );
    if (balance.available_opening_balance_bulk > this.availableBalc) {
      balance.available_opening_balance_bulk = this.availableBalc;
    }
    if (balance.available_premium_balance_bulk > this.availablePremium) {
      balance.available_premium_balance_bulk = this.availablePremium;
    }
    // const gc_policy_start_date = isModify ? this.masterPolicyData.gc_policy_start_date : this.masterPolicyDetails.quote.data.gc_policy_start_date;
    // const gc_policy_end_date = isModify ? this.masterPolicyData.gc_policy_end_date : this.masterPolicyDetails.quote.data.gc_policy_end_date;
    let data = {
      product_id: this.commonVariablesService.declarationProductId,
      master_policy_no: this.masterPolicyNo,
      policy_id: policyId,
      sub_voyage_id: subVoyageAry.id,
      inputs: {
        ...excelValue,
        tp_policy_no: this.masterPolicyDetails.cust_fld_1,
        opening_balance: balance.available_opening_balance_bulk,
        balance_premium: balance.available_premium_balance_bulk,
        /* opening_balance: this.availableBalc,
        balance_premium: this.availablePremium, */
        policy_type: this.masterPolicyDetails.quote.data.policy_type,
        voyage_name: isModify
          ? this.masterPolicyDetails.quote.data.voyage_name
          : await this.commonService.getVoyageDesc(
              this.masterPolicyDetails.quote.data.voyage
            ),
        sub_voyage_type: subVoyageAry.sub_voyage_name,
        bulk_declaration_type: this.isSimpleBulkDeclaration
          ? "simple"
          : "detailed",
        certificate_allowed: subVoyageAry.certificate_allowed,
        master_policy_start_date: this.datePipe.transform(
          new Date(this.masterPolicyData.gc_policy_start_date),
          "dd-MM-yyyy"
        ),
        master_policy_end_date: this.datePipe.transform(
          new Date(this.masterPolicyData.gc_policy_end_date),
          "dd-MM-yyyy"
        ),
        tax_amount: this.masterPolicyDetails.quote.data.tax_applicable,
        tax_applicable: await this.commonService.taxApplicableStatus(
          this.masterPolicyDetails.quote.data.tax_applicable ||
            this.masterPolicyDetails.quote.data.tax_amount ||
            0
        ),
        per_seeding_limit: subVoyageAry.per_seeding_limit,
        backdate_days:
          subVoyageAry.back_date_days || subVoyageAry.backdate_days,
        days_post_expiry: subVoyageAry.days_post_expiry,
        coverage_type: subVoyageAry.coverage_type,
        consolidated_from_date: this.datePipe.transform(
          this.bulkDeclarationForm.controls.from_date.value,
          "yyyy-MM-dd"
        ),
		consolidated_to_date: this.datePipe.transform(
			this.bulkDeclarationForm.controls.to_date.value,
			"yyyy-MM-dd"
		  ),
        consolidated_cargo_value:
          Number(
            await this.removeSeparator(
              this.bulkDeclarationForm.controls.total_sales.value
            )
          ) || 0,
        // consolidated_cargo_value: Number(await this.removeSeparator(this.bulkDeclarationForm.controls.total_sales.value)) || 0.001,
        consolidated_duty_si:
          Number(
            await this.removeSeparator(
              this.bulkDeclarationForm.controls.duty_si.value
            )
          ) || 0,
        Certificate_Bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
        certificate_bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
        bov_percentage: subVoyageAry.bov_percentage,
        currency_type:
          this.masterPolicyDetails.quote.data.policy_currency_type ||
          this.masterPolicyDetails.quote.data.currency_type,
        marine_final_rate_percentage: isModify
          ? this.masterPolicyDetails.quote.data.marine_final_rate_percentage
          : subVoyageAry.marine_final_rate_percentage,
        master_policy_no: this.masterPolicyNo,
        sub_voyage_id: subVoyageAry.id,
        min_shipment_premium: subVoyageAry.min_shipment_premium,
      },
      outputs: [
        "cargo_si",
        "roe",
        "cargo_si_policy_currency",
        "total_si",
        "cargo_premium",
        "duty_premium",
        "total_premium",
        "gst",
        "net_premium_final",
        "si_deductible",
      ],
    };
    const response = await this.commonService.httpPostMethod(
      premiumCalcUrl,
      data,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status === 0) {
      const responseData = response.body.data;
      this.calcPremiumData = responseData;
      /* if (this.calcPremiumData.cells.covered_value > this.calcPremiumData.cells.pol_si) {
        return false;
      } */
      this.calcPremiumData.cells.total_declared_value_display =
        await this.checkInvalidAmount(
          this.calcPremiumData.cells.total_declared_value
        );
      this.calcPremiumData.cells.covered_value_display =
        await this.checkInvalidAmount(this.calcPremiumData.cells.covered_value);
      return true;
    } else if (response.body.status != -114) {
      await this.closeModal();
      const errorMsg = (response.body.txt || "").split("~");
      this.commonService.errorsmsg(
        errorMsg[1] || "Unable to calculate Premium",
        ""
      );
      return false;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get reactive form data.
   *********************************************/
  get f() {
    return this.bulkDeclarationForm.controls;
  }

  /*
   * Created By : Sharann N
   * Description : trigger when underwriter approves/rejects.
   *********************************************/
  async approveOrReject(flow) {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      //Ticket No 154865
      this.isShowSubmitButton = false;
      return;
    }
    this.isSubmitButtonDisable = true;
    const excelValue = await this.productInputAttach();
    const isEndorsement =
      JSON.stringify(this.selectedEndorsementData) != "{}" ? true : false;
    let valid = 0;
    let errorMsg;
    const ret: any = await this.calculateBulkPremium(excelValue);
    valid = ret ? 0 : -2;
    if (valid == 0) {
      //Ticket No 154865
      this.isShowSubmitButton = true;
      isEndorsement
        ? this.saveEndorsement(excelValue, flow)
        : this.uwReferralAction(excelValue, flow);
    } else if (valid == -1) {
      this.isSubmitButtonDisable = false;
      this.commonService.errorsmsg(errorMsg, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : focus on validation reqiured form field.
   *********************************************/
  async focusOnInvalidFormField(formName: FormGroup, fieldName: any = "") {
    if (fieldName) {
      const invalidControl = this.el.nativeElement.querySelector(
        '[formcontrolname="' + fieldName + '"]'
      );
      invalidControl.focus();
    } else {
      const key = await this.commonService.checkInvalidFormField(formName);
      if (key) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        );
        invalidControl.focus();
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to get selected subVoyage from the subVoyage array.
   *********************************************/
  async getSubVoyageAry(array) {
    this.header.sub_voyage_id = this.header.sub_voyage_id || 0;
    this.header.prev_sub_voyage_id = this.header.prev_sub_voyage_id || 0;
    let i = 0,
      j = 0,
      retAry: any = [];
    /* if (!this.isAlreadyGenerated) {
      loop:
      for (const [idx, obj] of (this.gcEndorsementDetails || []).entries()) {
        for (const [subIdx, subVoyageObj] of (obj.data.sub_voyage || []).entries()) {
          if ([this.header.sub_voyage_id, this.header.prev_sub_voyage_id].includes(subVoyageObj.id)) {
            i = idx;
            j = subIdx;
            break loop;
          }
        }
      }
    } else {
      retAry = (array || []).filter(value => (value.id == this.header.sub_voyage_id));
      if (retAry.length == 0) {
        retAry = (array || []).filter(value => (value.id == this.header.prev_sub_voyage_id));
      }
      if (retAry.length == 0 && this.isAlreadyGenerated) {
        retAry.push(
          ...this.gcPolicyDetails.data.sub_voyage.filter(value => {
            return (value.sub_voyage_name == this.masterPolicyDetails.quote.data.sub_voyage_type)
          })
        );
      }
      retAry = (retAry[0] || {});
    }
    retAry = (this.gcEndorsementDetails[i].data.sub_voyage[j] || {});
    retAry = (retAry || {}); */

    let details: any = array;
    // Ticket No : 176527 Same voyage name changes start
    if (this.f.from_date.value && !this.isAlreadyGenerated) {
      const obj = {
        expected_date_shipment: { value: this.f.from_date.value },
        voyage_name: { value: this.masterPolicyData.voyage_name },
        sub_voyage_type: { value: this.masterPolicyData.sub_voyage_type },
        risk_details: { value: this.header.risk_detail_serial },
        gc_running_id: { value: this.header.gc_running_id },
      };
      details = await this.commonService.getSelectedGcData(
        obj,
        this.gcEndorsementDetails,
        false
      );
      if (details.length) {
        let header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        header.policy_id = details[0].quote.data.policy_id || "";
        header.policy_no = details[0].quote.data.master_policy_no || "";
        header.sub_voyage_id = details[0].data.sub_voyage[0].id || 0;
        /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
        window.localStorage.setItem(
          "declaration-header",
          JSON.stringify(header)
        );
        this.header = JSON.parse(
          window.localStorage.getItem("declaration-header") || "{}"
        );
        this.masterPolicyDetails = details[0];
        this.masterPolicyNo = details[0].quote.data.master_policy_no;
        details = details[0].data.sub_voyage;
      }
    }
    retAry = (details || []).filter(
      (value) => value.id == this.header.sub_voyage_id
    );
    if (retAry.length == 0) {
      retAry = (array || []).filter(
        (value) => value.id == this.header.prev_sub_voyage_id
      );
    }
    if (retAry.length == 0 && this.isAlreadyGenerated) {
      retAry.push(
        ...this.gcPolicyDetails.data.sub_voyage.filter((value) => {
          return (
            value.sub_voyage_name ==
            this.masterPolicyDetails.quote.data.sub_voyage_type
          );
        })
      );
    }
    retAry = retAry[0] || {};
    if (JSON.stringify(retAry) == "{}") {
      this.commonService.errorsmsg("Unable to load sub voyage details", "");
    }
    return retAry;
  }

  /*
   * Created By : Sharann N
   * Description : get master policy balance.
   *********************************************/
  async calcPolicyBalance(policyNo, shipmentDate) {
    const avalBalcUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/policy_balance`;
    let balcParamData = {
      policy_no: policyNo,
    };
    //64VB validation
    if (shipmentDate == undefined || shipmentDate == null) {
      this.commonService.errorsmsg("Todate should not be empty", "");
      return;
    }
    if (shipmentDate) {
      balcParamData["date_of_dec"] = this.datePipe.transform(
        new Date(shipmentDate),
        "yyyy-MM-dd"
      );
    }
    const response =
      policyNo != undefined
        ? await this.commonService.httpGetMethod(
            avalBalcUrl,
            "application/json",
            true,
            balcParamData,
            "Declaration",
            this.impersonateFlag
          )
        : {
            data: {
              available_premium_balance_bulk: 0,
              available_opening_balance_bulk: 0,
              available_opening_balance_certificate: 0,
              available_premium_balance_certificate: 0,
            },
          };
    if (response.status == -114) {
      this.closeModal();
    }
    const ret = response.status == 0 ? response.data || {} : {};
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : check certificate has any nstp cases.
   *********************************************/
  async checkUwCase(data: any = {}) {
    const ret = await this.calculateBulkPremium(data);
    if (ret) {
      const isModify =
        this.header.policy_no != this.masterPolicyDetails.policy_no
          ? true
          : false;
      const subVoyageAry = isModify
        ? {
            days_post_expiry:
              this.masterPolicyDetails.quote.data.days_post_expiry,
            per_seeding_limit:
              this.masterPolicyDetails.quote.data.per_seeding_limit,
            bov_percentage: this.masterPolicyDetails.quote.data.bov_percentage,
          }
        : await this.getSubVoyageAry(this.masterPolicyDetails.data.sub_voyage);

      if (!this.isSimpleBulkDeclaration) {
        /* PSL Case */
        let isValidPsl = false;
        for (const obj of this.excelData) {
          isValidPsl =
            Number(obj["Duty_Sum_Insured"] || "0") +
              Number(obj["freight"] || "0") +
              Number(obj["invoice_Value"] || "0") >
              Number(subVoyageAry.per_seeding_limit) &&
            (JSON.stringify(this.calcPremiumData) != "{}"
              ? this.calcPremiumData.cells.covered_value || -1
              : 1) > 0
              ? true
              : false;
          if (isValidPsl) break;
        }
        await this.pushReferralReason(isValidPsl, this.pslMsg);
        if (isValidPsl) {
          // this.uwRefferralReasons.push(this.pslMsg);
        }

        /* Insufficient Balance Case */
        const totalDeclared =
          JSON.stringify(this.calcPremiumData) != "{}"
            ? this.calcPremiumData.cells.total_declared_value || 0
            : 0;

        let balance = await this.calcPolicyBalance(
          this.masterPolicyNo,
          //64VB changes
          this.f.to_date.value || ""
        );
        if (balance.available_opening_balance_bulk > this.availableBalc) {
          balance.available_opening_balance_bulk = this.availableBalc;
        }
        this.isNegativeBalnc =
          totalDeclared - balance.available_opening_balance_bulk > 0
            ? true
            : false;

        await this.pushReferralReason(
          this.isNegativeBalnc,
          this.negativeBalcMsg
        );
        if (this.isNegativeBalnc) {
          // this.uwRefferralReasons.push(this.negativeBalcMsg);
        }

        const isHavingUWCase = this.uwRefferralReasons.length ? 0 : 1;
        return isHavingUWCase;
      } else {
        /* PSL Case */
        /* const si_deductible = (JSON.stringify(this.calcPremiumData) != '{}') ? this.calcPremiumData.cells.si_deductible : 0;
        // const si_deductible = isModify ? this.masterPolicyDetails.quote.data.si_deductible : this.calcPremiumData.cells.si_deductible;
        if (Number(si_deductible) > Number(subVoyageAry.per_seeding_limit)) {
          this.uwRefferralReasons.push(this.pslMsg);
        } */
        const isHavingUWCase = this.uwRefferralReasons.length ? 0 : 1;
        return isHavingUWCase;
      }
    } else {
      return -1;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to save the bulk declaration.
   *********************************************/
  async saveQuoteData(data: any = {}) {
    await this.spinner.show();

    const subVoyageAry = this.isAlreadyGenerated
      ? {
          sub_voyage_name: this.masterPolicyDetails.quote.data.sub_voyage_type,
          certificate_bulk: this.isSimpleBulkDeclaration
            ? "simple"
            : "detailed",
          certificate_allowed:
            this.masterPolicyDetails.quote.data.certificate_allowed,
          bov_percentage: this.masterPolicyDetails.quote.data.bov_percentage,
          per_seeding_limit:
            this.masterPolicyDetails.quote.data.per_seeding_limit,
          backdate_days:
            this.masterPolicyDetails.quote.data.back_date_days ||
            this.masterPolicyDetails.quote.data.backdate_days,
          days_post_expiry:
            this.masterPolicyDetails.quote.data.days_post_expiry,
          mode_of_conveyance:
            this.masterPolicyDetails.quote.data.mode_of_conveyance,
          Certificate_Bulk: this.isSimpleBulkDeclaration
            ? "simple"
            : "detailed",
          coverage_type: this.masterPolicyDetails.quote.data.coverage_type,
          min_shipment_premium:
            this.masterPolicyDetails.quote.data.min_shipment_premium,
          marine_final_rate_percentage:
            this.masterPolicyDetails.quote.data.marine_final_rate_percentage,
        }
      : await this.getSubVoyageAry(this.masterPolicyDetails.data.sub_voyage);

    let balance = await this.calcPolicyBalance(
      this.masterPolicyNo,
      //64VB changes
      this.bulkDeclarationForm.controls.to_date.value
    );
    if (balance.available_opening_balance_bulk > this.availableBalc) {
      balance.available_opening_balance_bulk = this.availableBalc;
    }
    if (balance.available_premium_balance_bulk > this.availablePremium) {
      balance.available_premium_balance_bulk = this.availablePremium;
    }
    const tp_policy_no =
      this.masterPolicyDetails.cust_fld_1 ||
      this.masterPolicyDetails.policy_number;
    //to_date validation
    if (
      this.bulkDeclarationForm.controls.to_date.value == null ||
      this.bulkDeclarationForm.controls.to_date.value == undefined ||
      this.bulkDeclarationForm.controls.to_date.value == ""
    ) {
      this.commonService.errorsmsg("To date should not be empty", "");
      this.spinner.hide();
      return;
    }
    let excelArrayData = await this.setEmptyDataForExcel();
    let paramData: any = {
      ...excelArrayData[0],
      cust_fld_1: tp_policy_no,
      cust_fld_2: this.isSimpleBulkDeclaration
        ? this.bulkConsolidated
        : this.bulkTransitLevelDetailed,
      cust_fld_3: this.masterPolicyDetails.policy_no,
      cust_fld_4: subVoyageAry.id,
      cust_fld_9: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.voyage_name
        : await this.commonService.getVoyageDesc(
            this.masterPolicyDetails.quote.data.voyage
          ),
      cust_fld_8: this.masterPolicyDetails.quote.data.policy_ref_num || "",
      sub_voyage_id: subVoyageAry.id,
      quote_id: "",
      quote_no: "",
      product_id: this.commonVariablesService.declarationProductId,
      master_policy_no: this.masterPolicyDetails.policy_no,
      tp_policy_no: tp_policy_no,
      opening_balance: balance.available_opening_balance_bulk,
      balance_premium: balance.available_premium_balance_bulk,
      /* opening_balance: this.availableBalc,
      balance_premium: this.availablePremium, */
      policy_type: this.masterPolicyDetails.quote.data.policy_type,
      voyage_name: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.voyage_name
        : await this.commonService.getVoyageDesc(
            this.masterPolicyDetails.quote.data.voyage
          ),
      sub_voyage_type: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.sub_voyage_type
        : subVoyageAry.sub_voyage_name,
      certificate_bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
      bulk_declaration_type: this.isSimpleBulkDeclaration
        ? "simple"
        : "detailed",
      declaration_type: this.isSimpleBulkDeclaration ? "simple" : "detailed",
      certificate_allowed: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.certificate_allowed
        : subVoyageAry.certificate_allowed,
      currency_type:
        this.masterPolicyDetails.quote.data.policy_currency_type ||
        this.masterPolicyDetails.quote.data.currency_type,
      bov_percentage: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.bov_percentage
        : subVoyageAry.bov_percentage,
      marine_final_rate_percentage: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.marine_final_rate_percentage
        : subVoyageAry.marine_final_rate_percentage,
      master_policy_start_date: this.datePipe.transform(
        new Date(this.masterPolicyData.gc_policy_start_date),
        "dd-MM-yyyy"
      ),
      master_policy_end_date: this.datePipe.transform(
        new Date(this.masterPolicyData.gc_policy_end_date),
        "dd-MM-yyyy"
      ),
      tax_amount: this.masterPolicyDetails.quote.data.tax_applicable,
      tax_applicable: await this.commonService.taxApplicableStatus(
        this.masterPolicyDetails.quote.data.tax_applicable ||
          this.masterPolicyDetails.quote.data.tax_amount ||
          0
      ),
      per_seeding_limit: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.per_seeding_limit
        : subVoyageAry.per_seeding_limit,
      backdate_days: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.back_date_days ||
          this.masterPolicyDetails.quote.data.backdate_days
        : subVoyageAry.back_date_days || subVoyageAry.backdate_days,
      days_post_expiry: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.days_post_expiry
        : subVoyageAry.days_post_expiry,
      mode_of_conveyance: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.mode_of_conveyance
        : subVoyageAry.mode_of_conveyance,
      insured_name: this.masterPolicyDetails.quote.data.insured_name,
      consolidated_from_date: this.datePipe.transform(
        this.bulkDeclarationForm.controls.from_date.value,
        "yyyy-MM-dd"
      ),
      consolidated_to_date: this.datePipe.transform(
        this.bulkDeclarationForm.controls.to_date.value,
        "yyyy-MM-dd"
      ),
      /* consolidated_from_date: this.bulkDeclarationForm.controls.from_date.value,
      consolidated_to_date: this.bulkDeclarationForm.controls.to_date.value, */
      consolidated_cargo_value:
        Number(
          await this.removeSeparator(
            this.bulkDeclarationForm.controls.total_sales.value
          )
        ) || 0,
      // consolidated_cargo_value: Number(await this.removeSeparator(this.bulkDeclarationForm.controls.total_sales.value)) || 0.001,
      consolidated_duty_si:
        Number(
          await this.removeSeparator(
            this.bulkDeclarationForm.controls.duty_si.value
          )
        ) || 0,
      sum_insured_percentage:
        this.masterPolicyDetails.quote.data.policy_total_sum_insured ||
        subVoyageAry.si_percentage,
      Certificate_Bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
      coverage_type: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.coverage_type
        : subVoyageAry.coverage_type,
      back_date_limit_cert: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.back_date_limit_cert
        : subVoyageAry.backdate_days ||
          subVoyageAry.back_date_days ||
          subVoyageAry.backdate_days,
      back_dates_bulk_decl: this.isAlreadyGenerated
        ? this.masterPolicyDetails.quote.data.back_dates_bulk_decl
        : subVoyageAry.backdate_days ||
          subVoyageAry.back_date_days ||
          subVoyageAry.backdate_days,
      nstpyn: this.uwRefferralReasons.length ? "Yes" : "No",
      __finalize: 0,
      refferal_remark: this.referralRemarksVal,
      min_shipment_premium: subVoyageAry.min_shipment_premium,
      policy_start_date: new Date(
        this.datePipe.transform(
          this.bulkDeclarationForm.controls.from_date.value,
          "yyyy-MM-dd"
        )
      ),
      policy_end_date: this.masterPolicyData.gc_policy_end_date,
    };
    paramData = { ...paramData, ...data };

    /* Need to remove 'extraKeys' after insillion issue fixed */
    const isFromdate =
      this.uwRefferralReasons.indexOf(this.expiryDaysMsg) > -1 ? 1 : undefined;
    const isPsl =
      this.uwRefferralReasons.indexOf(this.pslMsg) > -1 ? 1 : undefined;
    const isOnHold =
      this.uwRefferralReasons.indexOf(this.holdMsg) > -1 ? 1 : undefined;
    let extraKeys = {
      is_fromdate_below_backdate: isFromdate,
      is_psl_exceeds: isPsl,
    };
    extraKeys = JSON.parse(JSON.stringify(extraKeys));
    let referralType = "";
    if (isFromdate) {
      referralType += "BACKDATION,";
    }
    if (isPsl) {
      referralType += "PSL,";
    }
    if (this.isNegativeBalnc) {
      referralType += "Insufficient balance,";
    }
    if (isOnHold) {
      referralType += `${this.uploadHoldMsg},`;
    }
    referralType = referralType.substring(0, referralType.length - 1);
    paramData = {
      ...paramData,
      ...extraKeys,
      ...{ referral_type: referralType },
    };

    if (
      (this.isSimpleBulkDeclaration && this.uwRefferralReasons.length == 0) ||
      (!this.isSimpleBulkDeclaration && referralType == "")
    ) {
      let paramMany = {
        isNegativeBalnc: this.isNegativeBalnc,
        policyId: this.masterPolicyNo,
        certificateDate: this.datePipe.transform(
          this.bulkDeclarationForm.controls.from_date.value,
          "dd-MM-yyyy"
        ),
        certificateSi:
          ((this.calcPremiumData || {}).cells || {}).total_declared_value || 0,
        isOnHold: isOnHold ? isOnHold : "",
        isPsl: isPsl ? isPsl : "",
        availableBalc: this.availableBalc ? this.availableBalc : "",
        availablePremium: this.availablePremium ? this.availablePremium : "",
        masterPolicyDetailsPolicyId: this.masterPolicyDetails.policy_id,
        quoteParam: paramData,
      };

      await this.spinner.show();
      let urlMany = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_bulk/saveQuoteData?productname=emarine`;
      let response = await this.commonService.httpPostMethod(
        urlMany,
        paramMany,
        "application/json",
        true,
        "Declaration"
      );

      if (response.body.status == -114) {
        await this.spinner.hide();
        await this.closeModal();
      }
      if (response.body.status == 0) {
        await this.spinner.hide();

        let name = this.bulkDeclarationForm.controls.file.value;
        let tmpId = response.body.data.document_id
          ? response.body.data.document_id
          : "";
        let fileRet = name
          ? tmpId
            ? await this.documentAttach(name, tmpId)
            : true
          : true;

        if (fileRet) {
          if (response.body.data.isNstpEnabledFromRes) {
            await this.closeModal();
            this.commonService.successmsg(
              `${
                !this.isSimpleBulkDeclaration &&
                (this.isNegativeBalnc || response.body.data.negativeBalcFromRes)
                  ? "Bulk Declaration referred to UW for approval. Your declared value is not completely covered due to insufficiency of balance"
                  : this.refToUW
              }`,
              ""
            );
          } else {
            this.commonService.successmsg(
              this.isSimpleBulkDeclaration &&
                (this.isNegativeBalnc || response.body.data.negativeBalcFromRes)
                ? "Bulk Declaration updated successfully. Your declared value is not completely covered due to insufficiency of balance"
                : this.bulkSuccessMsg,
              ""
            );
            this.isShowSubmitButton = false;
          }

          this.bulkDeclarationForm.reset();
          this.submitted = false;
          this.fileUpload.nativeElement.value = null;
          await this.rerender();
        } else {
          await this.spinner.hide();
          this.commonService.errorsmsg(
            "Error occuring while upload document",
            ""
          );
        }
      } else if (response.body.status != -114) {
        await this.spinner.hide();
        await this.closeModal();
        let tmpError = (response.body.txt || "").split("~");
        this.commonService.errorsmsg(tmpError[1] || response.body.txt, "");
      }
    } else {
      let response = await this.commonService.httpPostMethod(
        this.quoteUrl,
        paramData,
        "application/json",
        true,
        "Declaration",
        this.impersonateFlag
      );
      if (response.body.status == -114) {
        await this.spinner.hide();
        this.closeModal();
        return;
      }
      const negativeBalc =
        response.body.status == 0
          ? (response.body.data[0].quote.data.referral_type || "").indexOf(
              "Insufficient balance"
            ) > -1
            ? true
            : false
          : false;
      await this.checkNegativeBalance(negativeBalc);
      if (response.body.status == 0) {
        const responseData = response.body.data[0];
        this.isNstpEnabled =
          ((responseData.quote.data || {}).nstpyn || "") == "Yes"
            ? true
            : false;
        const paymentUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/payment`;
        const payParamData = {
          policy_id: response.body.data[0].policy_id,
        };
        const custPaymentResponse = await this.commonService.httpPostMethod(
          paymentUrl,
          payParamData,
          "application/json",
          true,
          "Declaration",
          this.impersonateFlag
        );
        if (custPaymentResponse.body.status == 0) {
          const name = this.bulkDeclarationForm.controls.file.value;
          const ret = name
            ? await this.documentAttach(name, response.body.data[0].document_id)
            : true;
          if (ret) {
            if (this.isNstpEnabled) {
              const nstpParam = {
                subject: "Assigned to UW",
                assign_to: this.commonVariablesService.uwLOneGrpCode,
                message: `Policy id is ${responseData.policy_id} assigned to you`,
              };
              const retUser = await this.assignto_user(
                responseData.policy_id,
                nstpParam
              );
              if (retUser.body.status == 0) {
                //for Underwriter mail
                //for last 2 consecutive zero declaration, psl, insufficient balance
                await this.commonService.sendDeclarationMail({
                  mail_purpose: "certificate_on_hold",
                  action: isOnHold
                    ? "nil_declaration"
                    : isPsl
                    ? "psl"
                    : "insufficient_blc",
                  policy_id: responseData.policy_id,
                });
                await this.closeModal();
                this.commonService.successmsg(
                  `${
                    !this.isSimpleBulkDeclaration &&
                    (this.isNegativeBalnc || negativeBalc)
                      ? "Bulk Declaration referred to UW for approval. Your declared value is not completely covered due to insufficiency of balance"
                      : this.refToUW
                  }`,
                  ""
                );
                this.bulkDeclarationForm.reset();
                this.submitted = false;
                this.fileUpload.nativeElement.value = null;
                await this.rerender();
              } else {
                await this.spinner.hide();
                this.commonService.errorsmsg(retUser.body.txt, "");
              }
            } else {
              let paymentResponse = await this.convertToDeclaration(
                responseData.quote_id
              );
              if (paymentResponse.body.status === 0) {
                const custPaymentUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/payment`;
                const paymentParam = {
                  policy_id: response.body.data[0].policy_id,
                };
                paymentResponse = await this.commonService.httpPostMethod(
                  custPaymentUrl,
                  paymentParam,
                  "application/json",
                  true,
                  "Declaration",
                  this.impersonateFlag
                );
                if (paymentResponse.body.status == 0) {
                  await this.commonService.sendDeclarationMail({
                    mail_purpose: "declaration_success",
                    policy_id: response.body.data[0].policy_id,
                  });
                  balance = await this.calcPolicyBalance(
                    response.body.data[0].master_policy_no,
                    //64VB changes
                    response.body.data[0].quote.data.consolidated_to_date
                  );
                  if (
                    balance.available_opening_balance_bulk > this.availableBalc
                  ) {
                    balance.available_opening_balance_bulk = this.availableBalc;
                  }
                  if (
                    balance.available_premium_balance_bulk >
                    this.availablePremium
                  ) {
                    balance.available_premium_balance_bulk =
                      this.availablePremium;
                  }
                  if (
                    (balance.policy_type || "").toLowerCase() !=
                    "project policy"
                  ) {
                    await this.commonService.lowBalanceTriggerMail({
                      users: [],
                      policy_no: response.body.data[0].quote.data.cust_fld_1,
                      shipment_date:
                        response.body.data[0].quote.data.consolidated_from_date,
                      sub_voyage_id:
                        response.body.data[0].quote.data.sub_voyage_id,
                      current_balance_amount:
                        balance.available_opening_balance_bulk,
                      policy_ref_num: "123",
                    });
                  }
                  this.commonService.successmsg(
                    this.isSimpleBulkDeclaration &&
                      (this.isNegativeBalnc || negativeBalc)
                      ? "Bulk Declaration updated successfully. Your declared value is not completely covered due to insufficiency of balance"
                      : this.bulkSuccessMsg,
                    ""
                  );
                  this.bulkDeclarationForm.reset();
                  this.submitted = false;
                  this.fileUpload.nativeElement.value = null;
                  await this.rerender();
                  await this.spinner.hide();
                } else if (paymentResponse.body.status != -114) {
                  this.commonService.errorsmsg(paymentResponse.body.txt, "");
                  await this.closeModal();
                }
              } else if (paymentResponse.body.status != -114) {
                this.commonService.errorsmsg(paymentResponse.body.txt, "");
                await this.closeModal();
              }
            }
          } else {
            await this.spinner.hide();
            this.commonService.errorsmsg(
              "Error occuring while upload document",
              ""
            );
          }
        } else if (custPaymentResponse.body.status != -114) {
          await this.spinner.hide();
          this.commonService.errorsmsg(
            custPaymentResponse.body.txt || this.errorMsg,
            ""
          );
        }
      } else if (response.body.status != -114) {
        await this.spinner.hide();
        await this.closeModal();
        const errorMsg = (response.body.txt || "").split("~");
        this.commonService.errorsmsg(
          errorMsg[1] || response.body.txt || this.errorMsg,
          ""
        );
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to open the modal template.
   *********************************************/
  async openModal(template: TemplateRef<any>) {
    await this.closeModal(); //close if any modal opened previously
    this.modalRef = await this.modalService.show(template, this.configCenter);
    this.spinner.hide();
  }

  /*
   * Created By : Sharann N
   * Description : agree to move nstp case.
   *********************************************/
  changeReferChkFlg() {
    if ($("#refer").prop("checked")) {
      $("#refer").prop("checked", false);
      this.isReferred = false;
    } else {
      $("#refer").prop("checked", true);
      this.isReferred = true;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to save the endorsement.
   *********************************************/
  async saveEndorsement(data: any = {}, flow = "") {
    this.spinner.show();
    this.submitted = true;
    const ret = await this.validateForm(flow);
    if (ret) {
      this.prdEndorsementDetails = await this.getEndorsementId(
        this.commonService.declarationPremiumEndorsement
      );
      const subVoyageAry = this.isAlreadyGenerated
        ? {
            sub_voyage_name:
              this.masterPolicyDetails.quote.data.sub_voyage_type,
            certificate_bulk: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            certificate_allowed:
              this.masterPolicyDetails.quote.data.certificate_allowed,
            bov_percentage: this.masterPolicyDetails.quote.data.bov_percentage,
            per_seeding_limit:
              this.masterPolicyDetails.quote.data.per_seeding_limit,
            backdate_days:
              this.masterPolicyDetails.quote.data.back_date_days ||
              this.masterPolicyDetails.quote.data.backdate_days,
            days_post_expiry:
              this.masterPolicyDetails.quote.data.days_post_expiry,
            mode_of_conveyance:
              this.masterPolicyDetails.quote.data.mode_of_conveyance,
            Certificate_Bulk: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            coverage_type: this.masterPolicyDetails.quote.data.coverage_type,
            marine_final_rate_percentage:
              this.masterPolicyDetails.quote.data.marine_final_rate_percentage,
          }
        : await this.getSubVoyageAry(this.masterPolicyDetails.data.sub_voyage);
      //64VB changes

      let balance = await this.calcPolicyBalance(
        this.masterPolicyNo,
        this.isAlreadyGenerated
          ? this.bulkDeclarationForm.controls.from_date.value
          : this.selectedDeclarationDetail.to_date_obj
      );
      if (balance.available_opening_balance_bulk > this.availableBalc) {
        balance.available_opening_balance_bulk = this.availableBalc;
      }
      if (balance.available_premium_balance_bulk > this.availablePremium) {
        balance.available_premium_balance_bulk = this.availablePremium;
      }
      const saveEndorsementUrl = `${this.commonVariablesService.baseURL}api/v2/eproposal`;

      const additionFields = {
        eproposal_id: this.isAlreadyGenerated
          ? this.selectedEndorsementData
            ? this.selectedEndorsementData.eproposal_id
            : ""
          : "",
        eproposal_no: "",
        product_id: this.commonVariablesService.declarationProductId,
        cert_id: "",
        prd_endorsement_id: this.prdEndorsementDetails.prd_endorsement_id,
        policy_id: this.isAlreadyGenerated
          ? this.masterPolicyDetails.policy_id
          : this.selectedDeclarationDetail
          ? this.selectedDeclarationDetail.policy_id
          : "",
        policy_no: this.masterPolicyDetails.policy_no,
        eproposal_status: this.isAlreadyGenerated
          ? this.bulkDeclarationForm
            ? this.bulkDeclarationForm.controls.uw_status.value
            : ""
          : "",
        eproposal_reason: this.isAlreadyGenerated
          ? this.bulkDeclarationForm
            ? this.bulkDeclarationForm.controls.uw_remark.value
            : ""
          : "",
        __finalize: this.isAlreadyGenerated ? 1 : 0,
      };
      // const isEndorsement = this.endorsementId ? true : false;
      // const master_policy_start_date = isEndorsement ? this.masterPolicyData.gc_policy_start_date : this.masterPolicyDetails.quote.data.gc_policy_start_date;
      // const master_policy_end_date = isEndorsement ? this.masterPolicyData.gc_policy_end_date : this.masterPolicyDetails.quote.data.gc_policy_end_date;
      const master_policy_start_date =
        this.masterPolicyData.gc_policy_start_date;
      const master_policy_end_date = this.masterPolicyData.gc_policy_end_date;
      //to_date validation
      if (this.isAlreadyGenerated == true) {
        if (
          this.bulkDeclarationForm.controls.to_date.value == null ||
          this.bulkDeclarationForm.controls.to_date.value == undefined ||
          this.bulkDeclarationForm.controls.to_date.value == ""
        ) {
          this.commonService.errorsmsg("Todate should not be empty", "");
          this.spinner.hide();
          return;
        }
      } else {
        if (
          this.selectedDeclarationDetail.to_date_obj == "" ||
          this.selectedDeclarationDetail.to_date_obj == null ||
          this.selectedDeclarationDetail.to_date_obj == undefined
        ) {
          this.commonService.errorsmsg("Todate should not be empty", "");
          this.spinner.hide();
          return;
        }
      }
      let paramData: any = {
        cust_fld_1:
          this.masterPolicyDetails.cust_fld_1 ||
          this.masterPolicyDetails.quote.data.voyage.policy_number,
        cust_fld_2: this.isSimpleBulkDeclaration
          ? this.bulkConsolidated
          : this.bulkTransitLevelDetailed,
        cust_fld_3: this.masterPolicyDetails.policy_no,
        cust_fld_4: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.sub_voyage_id
          : subVoyageAry.id,
        cust_fld_9: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.voyage_name
          : await this.commonService.getVoyageDesc(
              this.masterPolicyDetails.quote.data.voyage
            ),
        cust_fld_8:
          this.masterPolicyDetails.quote.data.policy_ref_num ||
          this.masterPolicyDetails.quote.data.cust_fld_8 ||
          "",
        sub_voyage_id: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.sub_voyage_id
          : subVoyageAry.id,
        quote_id:
          this.masterPolicyDetails.quote.data.quote_id ||
          this.selectedDeclarationDetail.quote_id,
        product_id: this.commonVariablesService.declarationProductId,
        master_policy_no: this.masterPolicyDetails.policy_no,
        tp_policy_no:
          this.masterPolicyDetails.cust_fld_1 ||
          this.masterPolicyDetails.quote.data.voyage.policy_number,
        opening_balance: balance.available_opening_balance_bulk,
        balance_premium: balance.available_premium_balance_bulk,
        /* opening_balance: this.availableBalc,
        balance_premium: this.availablePremium, */
        policy_type: this.masterPolicyDetails.quote.data.policy_type,
        voyage_name: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.voyage_name
          : await this.commonService.getVoyageDesc(
              this.masterPolicyDetails.quote.data.voyage
            ),
        sub_voyage_type: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.sub_voyage_type
          : subVoyageAry.sub_voyage_name,
        certificate_bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
        bulk_declaration_type: this.isSimpleBulkDeclaration
          ? "simple"
          : "detailed",
        declaration_type: this.isSimpleBulkDeclaration ? "simple" : "detailed",
        certificate_allowed: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.certificate_allowed
          : subVoyageAry.certificate_allowed,
        currency_type:
          this.masterPolicyDetails.quote.data.policy_currency_type ||
          this.masterPolicyDetails.quote.data.currency_type,
        bov_percentage: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.bov_percentage
          : subVoyageAry.bov_percentage,
        marine_final_rate_percentage: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.marine_final_rate_percentage
          : subVoyageAry.marine_final_rate_percentage,
        master_policy_start_date: this.datePipe.transform(
          new Date(master_policy_start_date),
          "dd-MM-yyyy"
        ),
        master_policy_end_date: this.datePipe.transform(
          new Date(master_policy_end_date),
          "dd-MM-yyyy"
        ),
        policy_start_date: new Date(
          this.datePipe.transform(
            this.isAlreadyGenerated
              ? this.bulkDeclarationForm.controls.from_date.value
              : this.selectedDeclarationDetail.from_date_obj,
            "yyyy-MM-dd"
          )
        ),
        policy_end_date: this.masterPolicyData.gc_policy_end_date,
        tax_amount:
          this.masterPolicyDetails.quote.data.tax_applicable ||
          this.masterPolicyDetails.quote.data.tax_amount,
        tax_applicable: await this.commonService.taxApplicableStatus(
          this.masterPolicyDetails.quote.data.tax_applicable ||
            this.masterPolicyDetails.quote.data.tax_amount ||
            0
        ),
        per_seeding_limit: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.per_seeding_limit
          : subVoyageAry.per_seeding_limit,
        backdate_days: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.back_date_days ||
            this.masterPolicyDetails.quote.data.backdate_days
          : subVoyageAry.back_date_days || subVoyageAry.backdate_days,
        days_post_expiry: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.days_post_expiry
          : subVoyageAry.days_post_expiry,
        mode_of_conveyance: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.mode_of_conveyance
          : subVoyageAry.mode_of_conveyance,
        /* consolidated_from_date: (this.isAlreadyGenerated) ? this.bulkDeclarationForm.controls.from_date.value : this.selectedDeclarationDetail.from_date_obj,
        consolidated_to_date: (this.isAlreadyGenerated) ? this.bulkDeclarationForm.controls.to_date.value : this.selectedDeclarationDetail.to_date_obj, */
        consolidated_from_date: this.datePipe.transform(
          this.isAlreadyGenerated
            ? this.bulkDeclarationForm.controls.from_date.value
            : this.selectedDeclarationDetail.from_date_obj,
          "yyyy-MM-dd"
        ),
        consolidated_to_date: this.datePipe.transform(
          this.isAlreadyGenerated
            ? this.bulkDeclarationForm.controls.to_date.value
            : this.selectedDeclarationDetail.to_date_obj,
          "yyyy-MM-dd"
        ),
        sum_insured_percentage:
          this.masterPolicyDetails.quote.data.policy_total_sum_insured ||
          subVoyageAry.si_percentage ||
          this.masterPolicyDetails.quote.data.sum_insured_percentage,
        Certificate_Bulk: this.isSimpleBulkDeclaration ? "simple" : "detailed",
        coverage_type: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.coverage_type
          : subVoyageAry.coverage_type,
        back_date_limit_cert: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.back_date_limit_cert
          : subVoyageAry.back_date_days || subVoyageAry.backdate_days,
        back_dates_bulk_decl: this.isAlreadyGenerated
          ? this.masterPolicyDetails.quote.data.back_dates_bulk_decl
          : subVoyageAry.back_date_days || subVoyageAry.backdate_days,
        uw_remark: this.isAlreadyGenerated
          ? this.bulkDeclarationForm.controls.uw_remark.value
          : (this.selectedDeclarationDetail.uw_remark || "") == ""
          ? this.bulkDeclarationForm.controls.uw_remark.value
          : this.selectedDeclarationDetail.uw_remark,
        vb_impact: this.isAlreadyGenerated
          ? this.bulkDeclarationForm.controls.vb_impact.value
          : (this.selectedDeclarationDetail.vb_impact || "") == ""
          ? this.bulkDeclarationForm.controls.vb_impact.value
          : this.selectedDeclarationDetail.vb_impact,
        client_remarks: this.bulkDeclarationForm.controls.client_remarks.value,
        uw_status: this.isAlreadyGenerated
          ? this.bulkDeclarationForm.controls.uw_status.value
          : this.selectedDeclarationDetail.uw_status == "-"
          ? ""
          : this.selectedDeclarationDetail.uw_status,
        endorsement_start_date: new Date(
          this.datePipe.transform(
            this.masterPolicyData.gc_policy_start_date,
            "yyyy-MM-dd"
          )
        ),
        referral_type: this.uploadHoldMsg,
      };

      let extraKeys = {};
      if (this.isSimpleBulkDeclaration) {
        extraKeys = {
          consolidated_cargo_value: Number(
            await this.removeSeparator(
              this.isAlreadyGenerated
                ? this.bulkDeclarationForm.controls.total_sales.value
                : this.selectedDeclarationDetail.total_sales || 0
            )
          ),
          // consolidated_cargo_value:  Number(await this.removeSeparator((this.isAlreadyGenerated) ? this.bulkDeclarationForm.controls.total_sales.value : this.selectedDeclarationDetail.total_sales || 0.001)),
          consolidated_duty_si: Number(
            await this.removeSeparator(
              this.isAlreadyGenerated
                ? this.bulkDeclarationForm.controls.duty_si.value
                : this.selectedDeclarationDetail.duty_si || 0
            )
          ),
        };
      }
      let excelArrayData =
        JSON.stringify(data) != "{}"
          ? await this.setEmptyDataForExcel()
          : [data];

      paramData = {
        ...excelArrayData[0],
        ...additionFields,
        ...paramData,
        ...data,
        ...extraKeys,
      };

      if (this.isSimpleBulkDeclaration) {
        let paramMany = {
          type: this.commonService.declarationPremiumEndorsement,
          userType: this.getUserType,
          impersonateFlag: this.impersonateFlag,
          endorsementNoteClientRemark: this.bulkDeclarationForm.controls
            .client_remarks.value
            ? `${this.bulkDeclarationForm.controls.client_remarks.value}`
            : "",
          policyId: this.selectedDeclarationDetail
            ? this.selectedDeclarationDetail.policy_id
            : "",
          uwStatus: this.bulkDeclarationForm.controls.uw_status.value
            ? this.bulkDeclarationForm.controls.uw_status.value
            : "",
          uwRemark: this.bulkDeclarationForm.controls.uw_remark.value
            ? this.bulkDeclarationForm.controls.uw_remark.value
            : "",
          selectedEndorsementId:
            JSON.stringify(this.selectedEndorsementData) == "{}"
              ? ""
              : this.selectedEndorsementData.endorsement_id,
          selectedEndorsementPolicyId:
            JSON.stringify(this.selectedEndorsementData) == "{}"
              ? ""
              : this.selectedEndorsementData.policy_id,
          fSiDeductible: this.f.si_deductible.value || "",
          masterPolicyDetailsCreatedBy: this.masterPolicyDetails.created_by,
          masterPolicyDetailsPolicyId: this.masterPolicyDetails.policy_id,
          eproposal: paramData,
        };

        await this.spinner.show();
        let urlMany = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/client_user_for_bulk/saveEndorsement`;
        let response = await this.commonService.httpPostMethod(
          urlMany,
          paramMany,
          "application/json",
          true,
          "Declaration"
        );

        if (response.body.status == -114) {
          await this.spinner.hide();
          await this.closeModal();
        }
        if (response.body.status == 0) {
          await this.spinner.hide();
          await this.closeModal();

          let name = this.bulkDeclarationForm.controls.file.value;
          let tmpId = response.body.data.document_id
            ? response.body.data.document_id
            : "";
          let fileRet = name
            ? tmpId
              ? await this.documentAttach(
                  name,
                  tmpId,
                  JSON.stringify(this.selectedEndorsementData) == "{}"
                    ? false
                    : true
                )
              : true
            : true;

          if (fileRet) {
            if (response.body.data.isAssignToUw) {
              this.commonService.successmsg(`${this.refToUW}`, "");
              await this.rerender();
            } else {
              this.commonService.successmsg(
                "Declaration data updated successfully",
                ""
              );
              this.gotoPageContent(
                this.getUserType == "underwriter" ||
                  this.getUserType == "helpdesk"
                  ? 0
                  : 1
              );
            }
          } else {
            await this.spinner.hide();
            this.commonService.errorsmsg(
              "Error occuring while upload document",
              ""
            );
          }
        } else if (response.body.status != -114) {
          await this.spinner.hide();
          await this.closeModal();
          let tmpError = (response.body.txt || "").split("~");
          this.commonService.errorsmsg(tmpError[1] || response.body.txt, "");
        }
      } else {
        let response = await this.commonService.httpPostMethod(
          saveEndorsementUrl,
          paramData,
          "application/json",
          true,
          "Declaration",
          this.impersonateFlag
        );
        if (response.body.status == -114) {
          this.closeModal();
        }
        if (response.body.status == 0) {
          if (
            (this.getUserType != "underwriter" &&
              this.getUserType != "helpdesk") ||
            ((this.getUserType == "underwriter" ||
              this.getUserType == "helpdesk") &&
              this.impersonateFlag)
          ) {
            const assignEndorsementUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/note/${response.body.data[0].endorsement_id}`;
            const assignParam = {
              subject: `Create ${this.commonService.declarationPremiumEndorsement}`,
              assign_to: this.commonVariablesService.uwLOneGrpCode,
              message: `${this.bulkDeclarationForm.controls.client_remarks.value}`,
            };
            response = await this.commonService.httpPostMethod(
              assignEndorsementUrl,
              assignParam,
              "application/json",
              true,
              "Declaration",
              this.impersonateFlag
            );
            if (response.body.status == 0) {
              await this.assignToUw();
              await this.rerender();
              this.closeModal();
            } else if (response.body.status != -114) {
              this.spinner.hide();
              await this.closeModal();
              this.commonService.errorsmsg(
                response.body.txt || this.errorMsg,
                ""
              );
            }
          } else {
            if (
              this.bulkDeclarationForm.controls.uw_status.value == "Approve"
            ) {
              const paymentUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/payment`;
              const paymentParams = {
                policy_id: this.selectedEndorsementData.policy_id,
                endorsement_id:
                  JSON.stringify(this.selectedEndorsementData) == "{}"
                    ? ""
                    : this.selectedEndorsementData.endorsement_id,
              };
              if (JSON.stringify(this.selectedEndorsementData) == "{}") {
                delete paymentParams["endorsement_id"];
              }
              const paymentResponse = await this.commonService.httpPostMethod(
                paymentUrl,
                paymentParams,
                "application/json",
                true,
                "Declaration",
                this.impersonateFlag
              );
              if (paymentResponse.body.status == 0) {
                const name = this.bulkDeclarationForm.controls.file.value;
                const fileRet = name
                  ? await this.documentAttach(
                      name,
                      response.body.data[0].document_id,
                      JSON.stringify(this.selectedEndorsementData) == "{}"
                        ? false
                        : true
                    )
                  : true;
                if (fileRet) {
					 /* ON_HOLD FIX */
					 let fromInPaymentUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/payment_total_amount/${response.body.data[0].payment.policy_id}`;
					 let fromInPaymentRes = await this.commonService.httpGetMethod(fromInPaymentUrl, 'application/json', true, {}, 'Declaration', this.impersonateFlag);
					 let fromInPaymentVal;

					 if (fromInPaymentRes.status == 0) {
						 fromInPaymentVal = (fromInPaymentRes.data[0] || {}).total_amount || 0;
					 } else if (fromInPaymentRes.status != -114) {
						 this.commonService.errorsmsg(fromInPaymentRes.txt || 'Unable to get payment detail', '');
					 }
					 /* ON_HOLD FIX */
                  /* await this.assignEndorsementToClient(); */
                  const epaymentUrl = `${this.commonVariablesService.baseURL}api/v2/epayment/cash/${response.body.data[0].payment.payment_id}`;
                  const epaymentParams = {
                    amount:
                      Math.round(
                        (response.body.data[0].eproposal.data.si_deductible -
                          Number(this.f.si_deductible.value)) *
                          100
                      ) / 100,
                    office_location_code: "emarine2154",
                  };
                  let eresponse = await this.commonService.httpPostMethod(
                    epaymentUrl,
                    epaymentParams,
                    "application/json",
                    true,
                    "Declaration",
                    this.impersonateFlag
                  );
                  if (eresponse.body.status == 0) {
                    await this.assignEndorsementToClient();
                  } else if (eresponse.body.status != -114) {
                    this.spinner.hide();
                    await this.closeModal();
                    this.commonService.errorsmsg(
                      "Error occuring while payment",
                      ""
                    );
                  }
                } else {
                  this.spinner.hide();
                  await this.closeModal();
                  this.commonService.errorsmsg(
                    "Error occuring while upload document",
                    ""
                  );
                }
              } else if (paymentResponse.body.status != -114) {
                this.spinner.hide();
                await this.closeModal();
                this.commonService.errorsmsg(paymentResponse.body.txt, "");
              }
            } else {
              await this.assignEndorsementToClient();
            }
          }
        } else if (response.body.status != -114) {
          this.spinner.hide();
          this.commonService.errorsmsg(response.body.txt || this.errorMsg, "");
        }
      }
    } else {
      this.spinner.hide();
      //Ticket No -154865
      this.isSubmitButtonDisable = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
    }
  }

  /*
   * Created By : Sharann N
   * Description : get insillion endorsement details.
   *********************************************/
  async getEndorsementId(type) {
    const avalBalcUrl = `${this.commonVariablesService.baseURL}api/v1/product/endorsement`;
    const balcParamData = {
      product_id: this.commonVariablesService.declarationProductId,
    };
    const response = await this.commonService.httpGetMethod(
      avalBalcUrl,
      "application/json",
      true,
      balcParamData,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status == -114) {
      this.closeModal();
    }

    let ret = response.status == 0 ? response.data || [] : [];
    if (ret.length == 0) {
      this.commonService.errorsmsg(
        response.txt || "Unable to get endorsement details",
        ""
      );
    }
    ret = ret.filter((value) => {
      return (
        (value.endorsement_name || "").toLowerCase().replace(/\s/g, "") == type
      );
    });
    return ret[0] || {};
  }

  /*
   * Created By : Sharann N
   * Description : check the bulk declaration has endorsement or not.
   *********************************************/
  async checkEndorsement(data: any = {}) {
    this.isModify ? this.saveEndorsement(data) : this.saveQuoteData(data);
  }

  /*
   * Created By : Sharann N
   * Description : will refer to underwriter due to nstp cases.
   *********************************************/
  async uwAction() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }
    this.isShowSubmitButton = true;
    this.spinner.show();
    const ret = !this.isSimpleBulkDeclaration
      ? await this.validateForm()
      : true;
    if (ret) {
      this.isReferred = false;
      const excelValue = !this.isSimpleBulkDeclaration
        ? await this.productInputAttach()
        : {};
      await this.saveQuoteData(excelValue);
    } else {
      this.spinner.hide();
    }
    this.isShowSubmitButton = false;
  }

  /*
   * Created By : Sharann N
   * Description : get referral remark entered by user.
   *********************************************/
  referralRemarks(value) {
    this.referralRemarksVal = value;
  }

  /*
   * Created By : Sharann N
   * Description : get the endorsement details.
   *********************************************/
  async getEndromentDetails(endoresId) {
    const endorsementUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/${endoresId}`;
    const response = await this.commonService.httpGetMethod(
      endorsementUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    let ret = response.status == 0 ? response.data[0] || {} : {};
    if (JSON.stringify(ret) == "{}") {
      this.commonService.errorsmsg(
        response.txt || "Unable to get endorsement details",
        ""
      );
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : remove the form field validation.
   *********************************************/
  clearValidators(form: FormGroup) {
    return new Promise(async (resolve) => {
      for (const key in form.controls) {
        form.get(key).clearValidators();
        form.get(key).updateValueAndValidity();
      }
      resolve(true);
    });
  }

  /*
   * Created By : Sharann N
   * Description : check the field is required or not.
   *********************************************/
  isRequiredField(formFieldName) {
    const formField = this.bulkDeclarationForm.get(formFieldName);
    if (!formField.validator) {
      return false;
    }

    const validator = formField.validator({} as AbstractControl);
    return validator && validator.required;
  }

  /*
   * Created By : Sharann N
   * Description : to check selected bulk declaration is simple or detailed to open modal.
   *********************************************/
  async checkForm(template) {
    if (this.isSimpleBulkDeclaration) {
      const ret = this.getUserType != "helpdesk" ? await this.checkUwCase() : 1;
      if (ret == 0) {
        await this.openModal(this.uwCase);
      } else if (ret == 1) {
        await this.checkFile(template);
      }
    } else {
      this.uploadDeclarationData();
    }
  }

  /*
   * Created By : Sharann N
   * Description : check negative balance for bulk declaration.
   *********************************************/
  async checkNegativeBalance(negativeBalc) {
    if (this.isNegativeBalnc || negativeBalc) {
      await this.commonService.sendDeclarationMail({
        mail_purpose: "marine_dec_uncovered",
        policy_id: this.masterPolicyNo,
        certificate_date: this.datePipe.transform(
          this.bulkDeclarationForm.controls.from_date.value,
          "dd-MM-yyyy"
        ),
        certificate_si:
          ((this.calcPremiumData || {}).cells || {}).total_declared_value || 0,
        temp_name: "marine_dec_uncovered",
      });
    }
  }

  /*
   * Created By : Sharann N
   * Description : assign bulk declaration to underwriter.
   *********************************************/
  async assignToUw() {
    const uwParam = {
      subject: "Assigned to UW",
      assign_to: this.commonVariablesService.uwLOneGrpCode,
      message: `Policy id is ${this.selectedDeclarationDetail.policy_id} assigned to you`,
    };
    const ret = await this.assignto_user(
      this.selectedDeclarationDetail.policy_id,
      uwParam
    );
    if (ret.body.status == 0) {
      this.commonService.successmsg(`${this.refToUW}`, "");
      await this.commonService.sendDeclarationMail({
        mail_purpose: "certificate_modification",
        action: "request",
        policy_id: this.selectedDeclarationDetail.policy_id,
        cert_cli_rm: this.bulkDeclarationForm.controls.client_remarks.value,
      });
    } else {
      this.commonService.errorsmsg(ret.body.txt, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : get latest endorsment agianst selected bulk declaration.
   *********************************************/
  async getEndorsementIdpolicy(
    policyId: any = this.masterPolicyDetails.policy_id
  ) {
    const endIdUrl = `${this.commonVariablesService.baseURL}api/v2/endorsement/list/${policyId}`;
    const response = await this.commonService.httpGetMethod(
      endIdUrl,
      "application/json",
      true,
      {},
      "Declaration",
      this.impersonateFlag
    );
    let ret = {};
    if (response.status == 0) {
      const len = response.data.length;
      this.endorsementId = len ? response.data[len - 1].endorsement_id : "";
      ret = len ? await this.getEndromentDetails(this.endorsementId) : {};
    } else if (response.status != -114) {
      this.commonService.errorsmsg(response.txt, "");
    }
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : trigger when approve/reject endorsement for bulk declaration.
   *********************************************/
  async apprRejEndorse() {
    const approveUrl = `${this.commonVariablesService.baseURL}api/v2/eproposal/claim/${this.endorsementId}`;
    const aproveParam = {
      eproposal_status: this.bulkDeclarationForm.controls.uw_status.value,
      eproposal_reason: this.bulkDeclarationForm.controls.uw_remark.value,
    };
    const uwResponse = await this.commonService.httpPostMethod(
      approveUrl,
      aproveParam,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    return uwResponse;
  }

  /*
   * Created By : Sharann N
   * Description : assign policy to underwiter and also after approve/reject assign to the policy created user.
   *********************************************/
  async assignto_user(id, nstpParam, isEndorsement: boolean = false) {
    const nstpUrl = isEndorsement
      ? `${this.commonVariablesService.baseURL}api/v2/endorsement/note/${id}`
      : `${this.commonVariablesService.baseURL}api/v1/policy/note/${id}`;
    const nstpResponse = await this.commonService.httpPostMethod(
      nstpUrl,
      nstpParam,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    return nstpResponse;
  }

  /*
   * Created By : Sharann N
   * Description : check declaration is asiggned to group or not.
   *********************************************/
  async checkAssignee() {
    this.uwLevel = window.localStorage.getItem("uwLevel");
    //if assigned to is group
    if (
      [
        this.commonVariablesService.uwLOneGrpCode,
        this.commonVariablesService.uwLTwoGrpCode,
        this.commonVariablesService.uwLThreeGrpCode,
      ].includes(this.masterPolicyDetails["assigned_to"])
    ) {
      await this.takeOverAction(0);
      if (this.endorsementId) {
        await this.takeOverAction(1);
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to convert the policy assigned to group into assigned to me.
   *********************************************/
  async takeOverAction(isEndorsement) {
    const url = isEndorsement
      ? `${this.commonVariablesService.baseURL}api/v2/eproposal/claim/${this.selectedEndorsementData.endorsement_id}`
      : `${this.commonVariablesService.baseURL}api/v1/quote/claim/${this.header.quote_id}`;
    const response = await this.commonService.httpPostMethod(
      url,
      {},
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status == 0) {
      // successfully assigned here
    } else if (response.body.status != -114) {
      this.commonService.errorsmsg(response.body.txt, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : trigger when approve/reject the nstp case by underwriter.
   *********************************************/
  async uwReferralAction(data: any = {}, flow = "") {
    this.spinner.show();
    this.submitted = true;
    const ret = await this.validateForm(flow);
    if (ret) {
      if (this.bulkDeclarationForm.valid) {
        const status =
          this.bulkDeclarationForm.controls.uw_status.value == "Approve"
            ? "approved"
            : "rejected";
        let valid = true;

        let paramMany = {
          uwStatus: this.bulkDeclarationForm.controls.uw_status.value
            ? this.bulkDeclarationForm.controls.uw_status.value
            : "",
          uwRemark: this.bulkDeclarationForm.controls.uw_remark.value
            ? this.bulkDeclarationForm.controls.uw_remark.value
            : "",
          selectedEndorsementId:
            JSON.stringify(this.selectedEndorsementData) == "{}"
              ? ""
              : this.selectedEndorsementData.endorsement_id,
          masterPolicyDetailsQnstpId: this.masterPolicyDetails.qnstp_id,
          masterPolicyDetailsQuoteId: this.masterPolicyDetails.quote_id,
          masterPolicyDetailsCreatedBy: this.masterPolicyDetails.created_by,
          masterPolicyDetailsPolicyId: this.masterPolicyDetails.policy_id,
          masterPolicyId: this.masterPolicyId ? this.masterPolicyId : "",
          userType: this.getUserType,
          endorsementId: this.endorsementId ? this.endorsementId : "",
          quoteParam: "",
        };

        if (
          status == "approved" &&
          JSON.stringify(this.selectedEndorsementData) == "{}"
        ) {
          let balance = await this.calcPolicyBalance(
            this.masterPolicyNo,
            //64VB changes
            this.f.to_date.value
          );
          if (balance.available_opening_balance_bulk > this.availableBalc) {
            balance.available_opening_balance_bulk = this.availableBalc;
          }
          if (balance.available_premium_balance_bulk > this.availablePremium) {
            balance.available_premium_balance_bulk = this.availablePremium;
          }
          let excelArrayData = await this.setEmptyDataForExcel();
          let paramData: any = {
            ...excelArrayData[0],
            quote_id: this.masterPolicyDetails.quote_id,
            policy_id: this.masterPolicyDetails.policy_id,
            product_id: this.commonVariablesService.declarationProductId,
            //64VB changes
            marine_final_rate_percentage:
              this.masterPolicyDetails.quote?.data
                ?.marine_final_rate_percentage,
            opening_balance: balance.available_opening_balance_bulk,
            balance_premium: balance.available_premium_balance_bulk,
            consolidated_from_date: this.datePipe.transform(
              this.bulkDeclarationForm.controls.from_date.value,
              "yyyy-MM-dd"
            ),
            consolidated_to_date: this.datePipe.transform(
              this.bulkDeclarationForm.controls.to_date.value,
              "yyyy-MM-dd"
            ),
            /* consolidated_from_date: this.bulkDeclarationForm.controls.from_date.value,
            consolidated_to_date: this.bulkDeclarationForm.controls.to_date.value, */
            consolidated_cargo_value:
              Number(
                await this.removeSeparator(
                  this.bulkDeclarationForm.controls.total_sales.value
                )
              ) || 0,
            // consolidated_cargo_value: Number(await this.removeSeparator(this.bulkDeclarationForm.controls.total_sales.value)) || 0.001,
            consolidated_duty_si:
              Number(
                await this.removeSeparator(
                  this.bulkDeclarationForm.controls.duty_si.value
                )
              ) || 0,
            __finalize: 0,
            quote_no: "",
            master_policy_no: this.masterPolicyDetails.master_policy_no,
            sub_voyage_id: this.masterPolicyDetails.quote.data.sub_voyage_id,
            bov_percentage: this.masterPolicyDetails.quote.data.bov_percentage,
            uw_ref_type: this.masterPolicyDetails.quote.data.referral_type,
            referral_type: this.masterPolicyDetails.quote.data.referral_type,
            reason_nstp: this.bulkDeclarationForm.controls.uw_remark.value,
            certificate_bulk: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            bulk_declaration_type: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            declaration_type: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            Certificate_Bulk: this.isSimpleBulkDeclaration
              ? "simple"
              : "detailed",
            policy_start_date: new Date(
              this.datePipe.transform(
                this.bulkDeclarationForm.controls.from_date.value,
                "yyyy-MM-dd"
              )
            ),
            policy_end_date: this.masterPolicyData.gc_policy_end_date,
            ...data,
          };

          paramMany["quoteParam"] = paramData;
        }
            // document attach function
              const name = this.bulkDeclarationForm.controls.file.value;
              const ret_file = name ? await this.documentAttach(name, this.documentId) : true;
              if(ret_file){
          
        let urlMany = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/uw_user_for_bulk/uwReferralAction`;
        let response = await this.commonService.httpPostMethod(
          urlMany,
          paramMany,
          "application/json",
          true,
          "Declaration",
          this.impersonateFlag
        );

        if (response.body.status == -114) {
          await this.spinner.hide();
          await this.closeModal();
        }
        if (response.body.status == 0) {
          await this.spinner.hide();
          await this.closeModal();

          if (JSON.stringify(this.selectedEndorsementData) != "{}") {
            this.bulkDeclarationForm.controls.uw_status.value == "Approve"
              ? this.commonService.successmsg(`${status}`, "")
              : this.commonService.errorsmsg(`${status}`, "");
          } else {
            this.commonService.successmsg(
              "Declaration data updated successfully",
              ""
            );
            if (this.bulkDeclarationForm.controls.uw_status.value != "Reject") {
              this.isShowSubmitButton = false;
            }
          }

          this.gotoPageContent(
            this.getUserType == "underwriter" || this.getUserType == "helpdesk"
              ? 0
              : 1
          );
        } else if (response.body.status != -114) {
          await this.spinner.hide();
          await this.closeModal();

          let tmpError = (response.body.txt || "").split("~");
          this.commonService.errorsmsg(tmpError[1] || response.body.txt, "");
        }
      } else {
        this.spinner.hide();
        await this.closeModal();
        this.commonService.errorsmsg('Error occuring while upload document', '');
      }
      } else {
        this.spinner.hide();
        //Ticket No -154865
        this.isSubmitButtonDisable = false;
        await this.focusOnInvalidFormField(this.bulkDeclarationForm);
      }
    } else {
      this.spinner.hide();
      //Ticket No -154865
      this.isSubmitButtonDisable = false;
      this.commonService.warningmsg("Please fill Mandatory fields", "Warning");
      this.isSubmitButtonDisable = false;
    }
  }

  /*
   * Created By : Sharann N
   * Description : close underwriter modal template.
   *********************************************/
  async closeUwCase() {
    this.isModify = false;
    await this.closeModal();
  }

  /*
   * Created By : Sharann N
   * Description : validate the uploaded excel.
   *********************************************/
  async excelFieldValidation() {
    this.sampleData = [];
    if (this.excelData.length == 0) {
      this.sampleData.push({
        statusmsg: "Failure",
        statusreason: "No data Available",
      });
      this.excelData = this.sampleData;
      return false;
    }
    for (var x = 0; x < this.excelData.length; x++) {
      let errorMsg = "";
      let tempAry = {};
      for (var y = 0; y < this.excelHeaders.length; y++) {
        let headerName = this.excelHeaders[y];
        let headerFlag = 0;
        if (headerName.toLowerCase() != "statusmsg") {
          if (headerName in this.excelData[x]) {
            headerFlag = 1;
            tempAry[this.excelHeadersKey[y]] = this.excelData[x][headerName];
          } else {
            tempAry[this.excelHeadersKey[y]] =
              this.excelData[x][this.excelHeadersKey[y]];
          }
          let paramData =
            headerFlag != 0
              ? this.excelData[x][headerName]
              : this.excelData[x][this.excelHeadersKey[y]];

          let chkMandatory = this.excelData1[y].isMandatory;
          let fieldType = this.excelData1[y].dataType;
          let regex = this.excelData1[y].regex;
          if (chkMandatory == true && this.commonService.checkNull(paramData)) {
            errorMsg += headerName + " is Required" + ",";
          }
          if (
            paramData &&
            ((fieldType.toLowerCase() == "numeric" && isNaN(paramData)) ||
              ((fieldType.toLowerCase() == "varchar" ||
                fieldType.toLowerCase() == "alphanumeric") &&
                (regex ? !regex.test(paramData) : !isNaN(paramData))))
          ) {
            errorMsg += headerName + " should be " + fieldType + ",";
          }
          if (headerName == "Invoice Value" && Number(paramData) == 0) {
            errorMsg += headerName + " should not be zero,";
          }
          if (["Invoice Date", "LR/AWB/BL Date"].includes(headerName)) {
            if (paramData) {
              if (String(paramData).indexOf("/") > -1) {
                tempAry[this.excelHeadersKey[y]] = paramData;
                errorMsg += headerName + " should be DD-MM-YYYY" + ",";
              } else {
                tempAry[this.excelHeadersKey[y]] =
                  String(paramData).indexOf("-") > -1
                    ? paramData
                    : this.datePipe.transform(
                        await this.commonService.excelDateToJSDate(paramData),
                        "dd-MM-yyyy"
                      );
                if (headerName == "LR/AWB/BL Date") {
                  let expiryDate = this.masterPolicyData.gc_policy_end_date;
                  let expiryDateValue = new Date(expiryDate);
                  let startDate = this.masterPolicyData.gc_policy_start_date;
                  let startDateValue = new Date(startDate);
                  let myMoment: moment.Moment = moment(
                    paramData,
                    "DD-MM-YYYY",
                    true
                  );
                  let sampleDateValue, dateArray, covertDate;
                  if (myMoment["_d"] == "Invalid Date") {
                    sampleDateValue =
                      await this.commonService.excelDateToJSDate(paramData);
                    covertDate = this.datePipe.transform(
                      sampleDateValue,
                      "dd-MM-yyyy"
                    );
                  }
                  dateArray = sampleDateValue
                    ? covertDate.split("-")
                    : paramData.split("-");
                  var date = new Date(
                    dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0]
                  );
                  if (date < startDateValue || date > expiryDateValue) {
                    errorMsg +=
                      headerName + " should be within master policy period,";
                  }
                }
              }
            }
          }
        }
      }
      if (!this.commonService.checkNull(errorMsg)) {
        errorMsg = errorMsg.substring(0, errorMsg.length - 1);
        tempAry["statusmsg"] = errorMsg;
      } else {
        tempAry["statusmsg"] = this.successTxt;
      }

      this.sampleData.push(tempAry);
    }
    this.excelData = [];
    this.excelData = this.sampleData;
    let isValid: boolean = true;
    for (const obj of this.excelData) {
      if (obj.statusmsg.toLowerCase() != "success") {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  /*
   * Created By : Sharann N
   * Description : to download the excel.
   *********************************************/
  exportAsExcel() {
    let exlAry = [];
    let excelData = JSON.parse(JSON.stringify(this.excelData));
    for (const obj of excelData || []) {
      let statusDetail = obj.statusmsg;
      if (statusDetail.toLowerCase() != "success") {
        exlAry.push(obj);
      }
    }
    this.excelService.exportExcel(
      exlAry.length == 0 ? excelData : exlAry,
      "Bulk_Detailed_Template.xlsx"
    );
  }

  /*
   * Created By : Sharann N
   * Description : convert to date string.
   *********************************************/
  convertToDateString(date) {
    return new Promise(async (resolve) => {
      date = date.split("-");
      let dateField = date[0];
      let monthField = date[1];
      let yearField = date[2];
      if (date[0].length > 3) {
        dateField = date[2];
        monthField = date[1];
        yearField = date[0];
      }
      // return new Date(parseInt(yearField), parseInt(monthField) - 1, parseInt(dateField));
      return resolve(
        new Date(
          parseInt(yearField),
          parseInt(monthField) - 1,
          parseInt(dateField)
        )
      );
    });
  }

  /*
   * Created By : Sharann N
   * Description : assign the endorsement to created user.
   *********************************************/
  async assignEndorsementToClient() {
    const assignParam = {
      subject: `Update ${this.commonService.declarationPremiumEndorsement}`,
      assign_to: this.masterPolicyDetails.created_by,
      message: `${this.bulkDeclarationForm.controls.uw_remark.value}`,
    };
    let ret = await this.assignto_user(
      this.selectedEndorsementData.endorsement_id,
      assignParam,
      true
    );
    if (ret.body.status == 0) {
      ret = await this.assignto_user(
        this.masterPolicyDetails.policy_id,
        assignParam
      );
      if (ret.body.status == 0) {
        this.commonService.successmsg(
          "Declaration data updated successfully",
          ""
        );
        await this.commonService.sendDeclarationMail({
          mail_purpose: "uw_actions_on_bulk",
          // mail_purpose: this.selectedEndorsementData.eproposal.data.referral_type == this.uploadHoldMsg ? 'certificate_modification' : 'uw_actions_on_bulk',
          action:
            this.bulkDeclarationForm.controls.uw_status.value == "Approve"
              ? "approved"
              : "reject",
          policy_id: this.masterPolicyDetails.policy_id,
        });
        /* const consolidated_from_date = ((this.selectedEndorsementData.eproposal.data.consolidated_from_date).indexOf('T') === -1) ? this.selectedEndorsementData.eproposal.data.consolidated_from_date : this.datePipe.transform(this.selectedEndorsementData.eproposal.data.consolidated_from_date, 'yyyy-MM-dd');
        let balance: any = await this.calcPolicyBalance(this.selectedEndorsementData.eproposal.data.master_policy_no, consolidated_from_date);
        if (balance.available_opening_balance_bulk > this.availableBalc) {
          balance.available_opening_balance_bulk = this.availableBalc;
        }
        if (balance.available_premium_balance_bulk > this.availablePremium) {
          balance.available_premium_balance_bulk = this.availablePremium;
        }
        if ((balance.policy_type || '').toLowerCase() != 'project policy') {
          await this.commonService.lowBalanceTriggerMail({
            users: [],
            policy_no: this.selectedEndorsementData.eproposal.data.cust_fld_1,
            shipment_date: consolidated_from_date,
            sub_voyage_id: this.selectedEndorsementData.eproposal.data.sub_voyage_id,
            current_balance_amount: balance.available_opening_balance_certificate,
            policy_ref_num: '123'
          });          
        } */
        await this.closeModal();
        this.gotoPageContent(
          this.getUserType == "underwriter" || this.getUserType == "helpdesk"
            ? 0
            : 1
        );
      } else {
        this.spinner.hide();
        this.commonService.errorsmsg(ret.body.txt || this.errorMsg, "");
      }
    } else {
      this.spinner.hide();
      this.commonService.errorsmsg(ret.body.txt || this.errorMsg, "");
    }
  }

  /*
   * Created By : Sharann N
   * Description : refer to next level user.
   *********************************************/
  async referToNextLvl() {
    const res = await this.checkPolicyValidOrNot();
    if (res) {
      return;
    }

    await this.spinner.show();
    let paramMany = {
      type: this.commonService.declarationPremiumEndorsement,
      uwLevel: this.uwLevel ? this.uwLevel : "",
      uwRemark: this.bulkDeclarationForm.controls.uw_remark.value
        ? this.bulkDeclarationForm.controls.uw_remark.value
        : "",
      selectedEndorsementId:
        JSON.stringify(this.selectedEndorsementData) == "{}"
          ? ""
          : this.selectedEndorsementData.endorsement_id,
      masterPolicyDetailsPolicyId: this.masterPolicyDetails.policy_id,
      masterPolicyId: this.masterPolicyId ? this.masterPolicyId : "",
    };

    let urlMany = `${this.commonVariablesService.baseURL}api/v1/marine_declaration_common_api/uw_user_for_bulk/referToNextLvl`;
    let response = await this.commonService.httpPostMethod(
      urlMany,
      paramMany,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );

    if (response.body.status == -114) {
      await this.spinner.hide();
      await this.closeModal();
    }
    if (response.body.status == 0) {
      this.commonService.successmsg(
        `Refer to underwriter level ${
          this.uwLevel == "one" ? 2 : this.uwLevel == "two" ? 3 : ""
        }`,
        ""
      );
      await this.spinner.hide();
      await this.closeModal();
      this.gotoPageContent(
        this.getUserType == "underwriter" || this.getUserType == "helpdesk"
          ? 0
          : 1
      );
    } else if (response.body.status != -114) {
      this.commonService.errorsmsg(response.body.txt, "");
      await this.spinner.hide();
      await this.closeModal();
    }
  }

  /*
   * Created By : Sharann N
   * Description : convert the quote into policy(bulk declaration).
   *********************************************/
  async convertToDeclaration(quoteId) {
    this.spinner.show();
    const finalizeParam = {
      quote_id: quoteId,
    };
    let response = await this.commonService.httpPostMethod(
      `${this.quoteUrl}/finalize`,
      finalizeParam,
      "application/json",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status == 0) {
      let url = this.commonVariablesService.baseURL + "api/v1/proposal";
      let paramData = {
        proposal_id: response.body.data[0].proposal_id,
        quote_id: response.body.data[0].quote_id,
        policy_id: response.body.data[0].policy_id,
        __finalize: 0,
      };

      response = await this.commonService.httpPostMethod(
        url,
        paramData,
        "application/json",
        true,
        "Declaration",
        this.impersonateFlag
      );
      if (response.body.status == 0) {
        url = `${this.commonVariablesService.baseURL}api/v1/proposal/finalize/${response.body.data[0].proposal_id}`;
        response = await this.commonService.httpPostMethod(
          url,
          {},
          "application/json",
          true,
          "Declaration",
          this.impersonateFlag
        );
        if (response.body.status === 0) {
          let paymentUrl = `${this.commonVariablesService.baseURL}api/v1/payment/cash/${response.body.data[0].payment.payment_id}`;
          const paymentParams = {
            amount: response.body.data[0].quote.data.si_deductible,
            office_location_code: "emarine2154",
            // amount: Number(response.body.data[0].quote.data.si_deductible) == 0.001 ? 0 : response.body.data[0].quote.data.si_deductible
          };
          let paymentResponse = await this.commonService.httpPostMethod(
            paymentUrl,
            paymentParams,
            "application/json",
            true,
            "Declaration",
            this.impersonateFlag
          );
          this.isShowSubmitButton = false;
          //this.spinner.hide();
          return paymentResponse;
        } else if (response.body.status != -114) {
          this.commonService.errorsmsg(
            "Problem occuring while saving data",
            ""
          );
          await this.closeModal();
        }
      } else if (response.body.status != -114) {
        this.commonService.errorsmsg("Problem occuring while saving data", "");
        await this.closeModal();
      }
    } else if (response.body.status != -114) {
      this.commonService.errorsmsg("Problem occuring while saving data", "");
      await this.closeModal();
    }
  }

  /*
   * Created By : Sharann N
   * Description : agree for vb impact.
   *********************************************/
  vbImpact() {
    this.hasVBImpact = false;
    if (this.bulkDeclarationForm.controls.vb_impact.value == "Yes") {
      this.hasVBImpact = true;
    }
  }

  /*
   * Created By : Sharann N
   * Description : to upload the file.
   *********************************************/
  async documentAttach(fileName, document_id, isEndorsement: boolean = false) {
    const url = `${this.commonVariablesService.baseURL}api/v${
      isEndorsement ? "2" : "1"
    }/document/attach`;
    const fileData = new FormData();
    fileData.append("document_id", document_id);
    fileData.append("file", fileName);
    fileData.append("document_type", this.docDetails.file_ext);
    fileData.append("document_desc", "attachment");
    fileData.append("name", this.docDetails.file_name);
    const response = await this.commonService.httpPostMethod(
      url,
      fileData,
      "",
      true,
      "Declaration",
      this.impersonateFlag
    );
    if (response.body.status == 0) {
      return true;
    } else {
      this.commonService.errorsmsg(
        "Problem occuring while file attachment",
        ""
      );
      return false;
    }
  }

  /*
   * Created By : Sharann N
   * Description : trigger when sub voyage changes.
   *********************************************/
  async changeSubVoyageDetails(data) {
    const subVoyageAry = this.subVoyageAryDetails.filter((value) => {
      return value.sub_voyage_name == data;
    });
    if ((subVoyageAry || []).length) {
      let header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      header.sub_voyage_id = subVoyageAry[0].id;
      /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
      window.localStorage.setItem("declaration-header", JSON.stringify(header));
      this.header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      this.masterPolicyData = {
        voyage_name: await this.commonService.getVoyageDesc(
          this.masterPolicyDetails.quote.data.voyage
        ),
        sub_voyage_type: subVoyageAry[0].sub_voyage_name,
        certificate_bulk: await this.getCertificateBulk(
          this.masterPolicyDetails.quote.data.voyage
            .declaration_type_sub_voyage ||
            this.masterPolicyDetails.quote.data.voyage.declaration_type,
          subVoyageAry[0]
        ),
        bulk_declaration_type: subVoyageAry[0].bulk_declaration_type,
        gc_policy_start_date: this.masterPolicyData.gc_policy_start_date,
        gc_policy_end_date: this.masterPolicyData.gc_policy_end_date,
        // gc_policy_start_date: this.masterPolicyDetails.quote.data.gc_policy_start_date,
        // gc_policy_end_date: this.masterPolicyDetails.quote.data.gc_policy_end_date,
        bov_percentage: subVoyageAry[0].bov_percentage,
        sub_voyage_details: subVoyageAry[0],
      };
      this.isSimpleBulkDeclaration =
        (subVoyageAry[0].bulk_declaration_type || "").toLowerCase() ==
        this.bulkConsolidated.toLowerCase()
          ? true
          : false;
      await this.loadBulkDeclaredData();
    }
  }

  /*
   * Created By : Sharann N
   * Description : get the sub voyage array details to load dropdown.
   *********************************************/
  async getSubVoyageAryDetails() {
    let tempAry = [];
    if (this.isAlreadyGenerated) {
      // const gcPolicyDetails = await this.getPolicyData(this.masterPolicyNo, true);
      tempAry.push(
        ...this.gcPolicyDetails.data.sub_voyage.filter((value) => {
          return value.id == this.masterPolicyDetails.quote.data.sub_voyage_id;
        })
      );
      if (tempAry.length == 0) {
        tempAry.push(
          ...this.gcPolicyDetails.data.sub_voyage.filter((value) => {
            return (
              value.sub_voyage_name ==
              this.masterPolicyDetails.quote.data.sub_voyage_type
            );
          })
        );
      }
    } else {
      for (const dataObj of this.masterPolicyDetails.data.sub_voyage) {
        const days = dataObj.days_post_expiry;
        const dateObj = new Date((this.masterPolicyDetails.cust_fld_2) ? this.masterPolicyDetails.cust_fld_2 : this.masterPolicyDetails.quote.data.gc_policy_end_date);
        dateObj.setDate(dateObj.getDate() + Number(days));
        const isNotExpiried =
          new Date().getTime() <= dateObj.getTime() ? true : false;
        const isMop =
          (
            this.masterPolicyDetails.quote.data.policy_type || ""
          ).toUpperCase() == "MOP" ||
          (
            this.masterPolicyDetails.quote.data.policy_type || ""
          ).toUpperCase() == "OPEN COVER"
            ? true
            : false;
        const isRateApplicable =
          this.masterPolicyDetails.quote.data.voyage.rate_applicable.toUpperCase() ==
          "YES"
            ? true
            : false;
        if (
          isNotExpiried &&
          ((!isMop && isRateApplicable) ||
            (isMop && dataObj.certificate_bulk != "Certificate"))
        ) {
          tempAry.push({
            ...dataObj,
          });
        }
      }
    }
    return tempAry;
  }

  /*
   * Created By : Sharann N
   * Description : check invalid amount.
   *********************************************/
  checkInvalidAmount(value) {
    return new Promise(async (resolve) => {
      return resolve(
        String(value).trim() == "-" ||
          String(value).trim() == "#VALUE?" ||
          String(value).trim() == "0.01" ||
          String(value).trim() == "0.001"
          ? "0.00"
          : !Number(value) || Number(value) == 0
          ? "0.00"
          : Number(String(value).replace(/,/g, "").trim())
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    });
  }

  /*
   * Created By : Sharann N
   * Description : check master policy is active or not.
   *********************************************/
  async checkMasterPolicy() {
    if (this.isMasterPolicyInactived) {
      this.commonService.errorsmsg("Master policy is deleted", "");
      this.spinner.hide();
      await this.closeModal();
      return true;
    }
    return false;
  }

  /*
   * Created By : Sharann N
   * Description : navigate to child component.
   *********************************************/
  async navigateTo(idx, data) {
    if (data.valueText != "history") {
      const res = await this.checkPolicyValidOrNot();
      if (res) {
        return;
      }
    }
    let header = JSON.parse(
      window.localStorage.getItem("declaration-header") || "{}"
    );
    header.prev_quote_id = header.quote_id;
    header.prev_policy_id = header.policy_id;
    header.quote_id = this.bulkDeclUploadData[idx].quote_id;
    header.policy_id = this.bulkDeclUploadData[idx].policy_id;
    header.policy_no = this.bulkDeclUploadData[idx].master_policy_no;
    // header.tp_policy_no = this.bulkDeclUploadData[idx].policy_no;
    header.sub_voyage_id = this.bulkDeclUploadData[idx].sub_voyage_id;
    // header.nav_to = data.valueText;
    header.dup_cert_policy_no =
      this.bulkDeclUploadData[idx].dup_cert_policy_no || "";
    // header.reason = this.bulkDeclUploadData[idx].client_remarks || '';
    // header.referral_type = this.bulkDeclUploadData[idx].referral_type || '';
    /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
    window.localStorage.setItem("declaration-header", JSON.stringify(header));
    this.gotoPageContent(data.navTo);
  }

  /*
   * Created By : Sharann N
   * Description : to re-assign the gc details from master endorsement details.
   *********************************************/
  async reAssignGcData() {
    let details: any = [];
    // Ticket No : 176527 Same voyage name changes start
    if (this.f.from_date.value) {
      const obj = {
        expected_date_shipment: { value: this.f.from_date.value },
        voyage_name: { value: this.masterPolicyData.voyage_name },
        sub_voyage_type: { value: this.masterPolicyData.sub_voyage_type },
        risk_details: { value: this.header.risk_detail_serial },
        gc_running_id: { value: this.header.gc_running_id },
      };
      details = await this.commonService.getSelectedGcData(
        obj,
        this.gcEndorsementDetails,
        false
      );
    }
    if (details.length) {
      let header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      header.policy_id = details[0].quote.data.policy_id || "";
      header.policy_no = details[0].quote.data.master_policy_no || "";
      header.sub_voyage_id = details[0].data.sub_voyage[0].id || 0;
      /* sessionStorage.setItem('declaration-header', JSON.stringify(header)); */
      window.localStorage.setItem("declaration-header", JSON.stringify(header));
      this.header = JSON.parse(
        window.localStorage.getItem("declaration-header") || "{}"
      );
      this.masterPolicyDetails = details[0];
      this.masterPolicyNo = details[0].quote.data.master_policy_no;

      const balance = await this.calcPolicyBalance(this.masterPolicyNo, "");
      this.availableBalc = balance.available_opening_balance_bulk;
      this.availablePremium = balance.available_opening_balance_bulk;
      // this.availableBalc = details[0].data.sub_voyage[0].opening_balance
      // this.availablePremium = details[0].data.sub_voyage[0].premium_balance;
      await this.loadMasterPolicyDetails(false);
    }
  }

  /*
   * Created By : Sharann N
   * Description : to load master policy details to form.
   *********************************************/
  async loadMasterPolicyDetails(reAssignAry) {
    if (reAssignAry) {
      this.subVoyageAryDetails = await this.getSubVoyageAryDetails();
    }
    const subVoyageAry = await this.getSubVoyageAry(this.subVoyageAryDetails);
    this.isSimpleBulkDeclaration =
      (subVoyageAry.bulk_declaration_type || "").toLowerCase() ==
      this.bulkConsolidated.toLowerCase()
        ? true
        : false;
    const voyageName = this.isAlreadyGenerated
      ? this.masterPolicyDetails.quote.data.voyage_name
      : await this.commonService.getVoyageDesc(
          this.masterPolicyDetails.quote.data.voyage
        );
    const subVoyageName = subVoyageAry.sub_voyage_name;
    const gcRunningId = this.isAlreadyGenerated
      ? ""
      : this.masterPolicyDetails.quote.data.voyage.gc_running_id;
    let details = [];
    if (!this.isAlreadyGenerated && this.gcEndorsementDetails) {
      details = await this.commonService.getPolicyStartDate(
        gcRunningId,
        this.gcEndorsementDetails,
        this.header
      );
    }
    this.masterPolicyData = {
      voyage_name: voyageName,
      sub_voyage_type: subVoyageName,
      certificate_bulk: await this.getCertificateBulk(
        this.isAlreadyGenerated
          ? this.gcPolicyDetails.quote.data.voyage
              .declaration_type_sub_voyage ||
              this.gcPolicyDetails.data.declaration_type_sub_voyage
          : this.masterPolicyDetails.quote.data.voyage
              .declaration_type_sub_voyage ||
              this.masterPolicyDetails.data.declaration_type_sub_voyage,
        subVoyageAry
      ),
      bulk_declaration_type: subVoyageAry.bulk_declaration_type,
      gc_policy_start_date: this.isAlreadyGenerated
        ? await this.commonService.excelDateToJSDate(
            this.masterPolicyDetails.quote.data.master_policy_start_date
          )
        : details.length
        ? details[0].policy_inception_date
        : this.masterPolicyDetails.quote.data.gc_policy_start_date,
      // gc_policy_end_date: this.isAlreadyGenerated
      // 	? await this.commonService.excelDateToJSDate(
      // 			this.masterPolicyDetails.quote.data.master_policy_end_date
      // 	  )
      // 	: this.masterPolicyDetails.quote.data.gc_policy_end_date,
      //expiry change start
      gc_policy_end_date: this.isAlreadyGenerated
        ? this.gcPolicyDetails.cust_fld_2
          ? this.gcPolicyDetails.cust_fld_2
          : await this.commonService.excelDateToJSDate(
              this.masterPolicyDetails.quote.data.master_policy_end_date
            )
        : this.gcPolicyDetails.cust_fld_2
        ? this.gcPolicyDetails.cust_fld_2
        : this.masterPolicyDetails.quote.data.gc_policy_end_date,
      bov_percentage: subVoyageAry.bov_percentage,
      sub_voyage_details: subVoyageAry,
    };

    /* if(details[0].policy_code == 'RC'){
	//if(this.masterPolicyDetails.quote.data.renewal_counter != '000'){
		this.masterPolicyData.gc_policy_start_date = details[0].policy_inception_date;
		this.masterPolicyData.gc_policy_end_date = details[0].policy_expiry_date;
	} */
  }

  /*
   * Created By : Sharann N
   * Description : close the excel modal template.
   *********************************************/
  async closeExcelModal() {
    if (!this.excalValFlag) {
      this.f.file.setValue("");
      this.fileUpload.nativeElement.value = null;
    }
    await this.closeModal();
  }

  /*
   * Created By : Sharann N
   * Description : check user has allowed to generate bulk declaration or not.
   *********************************************/
  async getBulkDeclarationProp(response) {
    /* const mailID = this.cookie.get('email'); */
    const mailID = window.localStorage.getItem("email");
    let isOnlyViewable = false;
    for (const data of response.data.producer_users) {
      if (data.email == mailID) {
        isOnlyViewable =
          (data.allow_certificate || "").toLowerCase() == "no" ? true : false;
        break;
      }
    }
    this.isViewMode = ["marineclaims", "rm", "helpdesk", "ops"].includes(
      (this.getUserType || "").toLowerCase()
    )
      ? true
      : this.header.nav_to == "view_bulk" || isOnlyViewable
      ? true
      : false;
  }

  /*
   * Created By : Sharann N
   * Description : remove the `,` sepearator.
   *********************************************/
  async removeSeparator(data) {
    return data &&
      String(data).trim() != "-" &&
      String(data).trim() != "#VALUE?"
      ? String(data).replace(/,/g, "").trim()
      : 0;
  }

  /*
   * Created By : Sharann N
   * Description : check file is attached or not.
   *********************************************/
  async checkFile(template) {
    const fileAttached = this.bulkDeclarationForm.controls.file.value
      ? true
      : false;
    fileAttached
      ? await this.openModal(template)
      : await this.uploadDeclarationData();
  }

  /*
   * Created By : Sharann N
   * Description : get certificate bulk from sub-voyage level/declaration type from voyage level.
   *********************************************/
  getCertificateBulk(declaration_type_sub_voyage, subVoyageObj) {
    return (declaration_type_sub_voyage || "").toUpperCase() == "BOTH"
      ? subVoyageObj.certificate_bulk
      : declaration_type_sub_voyage;
  }

  /*
   * Created By : Sharann N
   * Description : to check policy's validity.
   *********************************************/
  async checkPolicyValidOrNot() {
    let res = await this.checkMasterPolicy();
    let valid = res ? 1 : 0;
    res = await this.commonService.checkPolicyExpiredOrNot(
      this.masterPolicyDetails.cust_fld_2 ? this.masterPolicyDetails.cust_fld_2 :this.masterPolicyDetails.quote.data.gc_policy_end_date,
      this.masterPolicyData.sub_voyage_details.days_post_expiry
    );
    valid = res ? valid + 1 : valid;
    const ret = valid > 0;
    return ret;
  }

  /*
   * Created By : Sharann N
   * Description : to assign policy's prev balance.
   *********************************************/
  async assignPrevBalance() {
    for (let idx = 0; idx < (this.bulkDeclUploadData || []).length; idx++) {
      if (
        this.isSimpleBulkDeclaration &&
        (this.bulkDeclUploadData[idx].total_sales == "0.001" ||
          this.bulkDeclUploadData[idx].total_sales == "0.01" ||
          this.bulkDeclUploadData[idx].total_sales == "0.00")
      ) {
        if (idx > 0) {
          if (this.bulkDeclUploadData[idx - 1].total_sales == 0.0) {
            this.bulkDeclUploadData[idx].avail_balance =
              this.bulkDeclUploadData[idx - 1].avail_balance;
          }
        }
      }
    }
  }

  /*
   * Created By : Sharann N
   * Description : to push referral reason without duplicate reason.
   *********************************************/
  async pushReferralReason(isUwCase, reason) {
    if (isUwCase) {
      if (this.uwRefferralReasons.indexOf(reason) === -1) {
        this.uwRefferralReasons.push(reason);
      }
    } else {
      // remove the referral reason
      this.uwRefferralReasons = this.uwRefferralReasons.filter(
        (e) => e !== reason
      );
    }
  }

  /*
   * Created By : Sharann N
   * Description : to form sample excel data for bulk-detailed.
   *********************************************/
  setEmptyDataForExcel() {
    return new Promise(async (resolve) => {
      let excelArray = [{}],
        tmpVal = "";
      for (let Count1 = 1; Count1 <= 200; Count1++) {
        for (let Count2 = 11; Count2 <= 13; Count2++) {
          tmpVal = "8_" + Count1 + "_" + Count2;
          excelArray[0][tmpVal] = "";
        }
      }
      return resolve(excelArray);
    });
  }

  /*
   * Created By : Sharann N
   * Description : to close the modal without await.
   *********************************************/
  closeTempModal() {
    if (this.modalRef) {
      this.isShowSubmitButton = false;
      this.modalRef.hide();
    }
  }
  /*
   * Created By : Sharann N
   * Description : to get the referred message.
   *********************************************/
  async getReferMsg() {
    const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/refer_msg`;
    const paramData = {
      policy_id: this.header.policy_id,
      subject: this.commonService.declarationPremiumEndorsement,
    };
    const response = await this.commonService.httpGetMethod(
      url,
      "application/json",
      true,
      paramData,
      "Declaration",
      this.impersonateFlag
    );
    if (response.status != 0 && response.status != -114) {
      this.commonService.errorsmsg(response.txt, "");
    }
    const responseData = response.data || [];
    return (responseData[responseData.length - 1] || [])["message"] || "";
  }
}
